// # # # # # # # # # # # # # # # # # #
// # Automatically generated file!   #
// # Update via: pnpm apollo:update  #
// # # # # # # # # # # # # # # # # # #

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
    T extends { [key: string]: unknown },
    K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
    | T
    | {
          [P in keyof T]?: P extends ' $fragmentName' | '__typename'
              ? T[P]
              : never;
      };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    DateTime: { input: any; output: any };
    Decimal: { input: any; output: any };
    InfraContextId: { input: any; output: any };
    InstitutionId: { input: any; output: any };
    JSON: { input: any; output: any };
    MonitoringPlanDraftId: { input: any; output: any };
    MonitoringPlanId: { input: any; output: any };
    NaiveDateTime: { input: any; output: any };
    OrganizationId: { input: any; output: any };
    QualityReportId: { input: any; output: any };
    UUID: { input: any; output: any };
    Upload: { input: any; output: any };
    YearlyReportId: { input: any; output: any };
};

/** Represents the input data for creating an access request. */
export type AccessRequestInput = {
    id: Scalars['ID']['input'];
};

/** Access state for IDP user attributes. */
export enum AccessState {
    Denied = 'DENIED',
    Granted = 'GRANTED',
    Pending = 'PENDING'
}

export enum AccessTy {
    R = 'R',
    W = 'W'
}

export type AccessValue = {
    __typename?: 'AccessValue';
    exclusive: Scalars['Boolean']['output'];
    present: Scalars['Boolean']['output'];
    ty: AccessTy;
};

export type Address = {
    __typename?: 'Address';
    additional?: Maybe<Scalars['String']['output']>;
    house?: Maybe<Scalars['String']['output']>;
    place?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    street?: Maybe<Scalars['String']['output']>;
    text?: Maybe<Scalars['String']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type AuthorityCreateFieldsInput = {
    address: CreateAddress;
    contact: CreateContact;
    name: Scalars['String']['input'];
    radioactiveObservations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuthorityCreateInput = {
    circleKey: Scalars['String']['input'];
    fields: AuthorityCreateFieldsInput;
    kind: CreateAuthorityKind;
};

export type AuthorityExportInput = {
    filter?: InputMaybe<AuthorityFilter>;
    ids?: InputMaybe<Array<Scalars['ID']['input']>>;
    search?: InputMaybe<AuthoritySearch>;
    sort?: InputMaybe<AuthoritySort>;
};

export type AuthorityFilter = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    editable?: InputMaybe<Scalars['Boolean']['input']>;
    federalStateBranchId?: InputMaybe<Scalars['Int']['input']>;
    federalStateId?: InputMaybe<Scalars['Int']['input']>;
    kind?: InputMaybe<Array<AuthorityKind>>;
    lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuthorityItem = {
    __typename?: 'AuthorityItem';
    active: Scalars['Boolean']['output'];
    address: Address;
    contact: Contact;
    editable?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    kind?: Maybe<AuthorityKind>;
    modification: Modification;
    name?: Maybe<Scalars['String']['output']>;
    province?: Maybe<Province>;
    r: Scalars['ID']['output'];
    radioactiveObservations?: Maybe<Scalars['Boolean']['output']>;
    readRights?: Maybe<Scalars['Boolean']['output']>;
};

export enum AuthorityKind {
    Ga = 'GA',
    Mb = 'MB',
    Ob = 'OB',
    So = 'SO',
    Wa = 'WA'
}

export type AuthorityList = {
    __typename?: 'AuthorityList';
    items: Array<AuthorityItem>;
    total: Scalars['Int']['output'];
};

export type AuthorityListInput = {
    filter?: InputMaybe<AuthorityFilter>;
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<AuthoritySearch>;
    sort?: InputMaybe<AuthoritySort>;
};

export type AuthorityRemoveInput = {
    ids: Array<Scalars['ID']['input']>;
};

export type AuthoritySearch = {
    fields?: InputMaybe<Array<AuthoritySearchField>>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export enum AuthoritySearchField {
    Address = 'ADDRESS',
    Id = 'ID',
    Name = 'NAME'
}

export type AuthoritySort = {
    by?: InputMaybe<AuthoritySortField>;
    order?: InputMaybe<SortOrder>;
};

export enum AuthoritySortField {
    Address = 'ADDRESS',
    CreatedAt = 'CREATED_AT',
    CreatedBy = 'CREATED_BY',
    House = 'HOUSE',
    Id = 'ID',
    Name = 'NAME',
    Place = 'PLACE',
    Street = 'STREET',
    UpdatedAt = 'UPDATED_AT',
    UpdatedBy = 'UPDATED_BY',
    Zip = 'ZIP'
}

export type AuthorityUpdateFieldsInput = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    address?: InputMaybe<UpdateAddress>;
    contact?: InputMaybe<UpdateContact>;
    name?: InputMaybe<Scalars['String']['input']>;
    radioactiveObservations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuthorityUpdateInput = {
    fields: AuthorityUpdateFieldsInput;
    id: Scalars['ID']['input'];
};

export type BasicEntityInfo = {
    __typename?: 'BasicEntityInfo';
    id?: Maybe<Scalars['ID']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    r?: Maybe<Scalars['ID']['output']>;
    ty: BasicEntityType;
};

export type BasicEntityInfoList = {
    __typename?: 'BasicEntityInfoList';
    items: Array<BasicEntityInfo>;
    total: Scalars['Int']['output'];
};

export enum BasicEntityType {
    Hdp = 'HDP',
    Lab = 'LAB',
    LabB = 'LAB_B',
    None = 'NONE',
    Obj = 'OBJ',
    Olb = 'OLB',
    OlbB = 'OLB_B',
    Spt = 'SPT',
    Sys = 'SYS',
    Wsp = 'WSP',
    WspB = 'WSP_B'
}

/** IDP user attributes for company (ELSTER) users. */
export type CompanyIdpUserAttributes = {
    __typename?: 'CompanyIdpUserAttributes';
    accessRole?: Maybe<UserAccessRole>;
    accessState?: Maybe<AccessState>;
    certificateType: Scalars['String']['output'];
    companyName: Scalars['String']['output'];
    country: Scalars['String']['output'];
    defaultTrustLevel: Scalars['String']['output'];
    email: Scalars['String']['output'];
    firstName: Scalars['String']['output'];
    house: Scalars['String']['output'];
    idpId: Scalars['String']['output'];
    lastName: Scalars['String']['output'];
    legalFormId: Scalars['String']['output'];
    legalFormText: Scalars['String']['output'];
    personType: Scalars['String']['output'];
    personalTitle: Scalars['String']['output'];
    place: Scalars['String']['output'];
    registryCourt: Scalars['String']['output'];
    registryNumber: Scalars['String']['output'];
    registryType: Scalars['String']['output'];
    storkQaaLevel: Scalars['String']['output'];
    street: Scalars['String']['output'];
    username: Scalars['String']['output'];
    zip: Scalars['String']['output'];
};

export type Contact = {
    __typename?: 'Contact';
    comment?: Maybe<Scalars['String']['output']>;
    email?: Maybe<Array<Scalars['String']['output']>>;
    mailbox?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Array<Scalars['String']['output']>>;
    website?: Maybe<Array<Scalars['String']['output']>>;
};

/** Context type for user access in GraphQL, matching backend shapth_auth::ContextType. */
export enum ContextType {
    Hdp = 'HDP',
    Lab = 'LAB',
    LabB = 'LAB_B',
    Olb = 'OLB',
    OlbB = 'OLB_B',
    Sys = 'SYS',
    Wsp = 'WSP',
    WspB = 'WSP_B'
}

/** Context version, matching backend shapth_auth::ContextVersion. */
export enum ContextVersion {
    V1 = 'V1',
    V2 = 'V2'
}

/** Counted object. */
export type Counted = {
    __typename?: 'Counted';
    amount: Scalars['Int']['output'];
    key: Scalars['String']['output'];
};

export type CreateAddress = {
    additional?: InputMaybe<Scalars['String']['input']>;
    house: Scalars['String']['input'];
    place: Scalars['String']['input'];
    state: Scalars['String']['input'];
    street: Scalars['String']['input'];
    zip: Scalars['String']['input'];
};

export type CreateAddressOpt = {
    additional?: InputMaybe<Scalars['String']['input']>;
    house?: InputMaybe<Scalars['String']['input']>;
    place?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    street?: InputMaybe<Scalars['String']['input']>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export enum CreateAuthorityKind {
    Ga = 'GA',
    So = 'SO',
    Wa = 'WA'
}

export type CreateContact = {
    comment?: InputMaybe<Scalars['String']['input']>;
    email: Array<Scalars['String']['input']>;
    mailbox?: InputMaybe<Scalars['String']['input']>;
    phone: Array<Scalars['String']['input']>;
    website: Array<Scalars['String']['input']>;
};

export type CreateSlimContact = {
    comment?: InputMaybe<Scalars['String']['input']>;
    email: Array<Scalars['String']['input']>;
    mailbox?: InputMaybe<Scalars['String']['input']>;
    phone: Array<Scalars['String']['input']>;
};

export type Csv = {
    __typename?: 'Csv';
    data: Scalars['String']['output'];
};

/** Represents the input data for grant an access request. */
export type DenyAccessInput = {
    users: Array<Scalars['UUID']['input']>;
};

export type FederalStateBranchExportInput = {
    filter?: InputMaybe<FederalStateBranchFilter>;
    ids?: InputMaybe<Array<Scalars['ID']['input']>>;
    search?: InputMaybe<FederalStateBranchSearch>;
    sort?: InputMaybe<FederalStateBranchSort>;
};

export type FederalStateBranchFilter = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    editable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FederalStateBranchItem = {
    __typename?: 'FederalStateBranchItem';
    active: Scalars['Boolean']['output'];
    address: Address;
    contact: Contact;
    editable?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    kind?: Maybe<AuthorityKind>;
    modification: Modification;
    name?: Maybe<Scalars['String']['output']>;
    province?: Maybe<Province>;
    r: Scalars['ID']['output'];
    radioactiveObservations?: Maybe<Scalars['Boolean']['output']>;
    readRights?: Maybe<Scalars['Boolean']['output']>;
};

export type FederalStateBranchList = {
    __typename?: 'FederalStateBranchList';
    items: Array<FederalStateBranchItem>;
    total: Scalars['Int']['output'];
};

export type FederalStateBranchListInput = {
    filter?: InputMaybe<FederalStateBranchFilter>;
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<FederalStateBranchSearch>;
    sort?: InputMaybe<FederalStateBranchSort>;
};

export type FederalStateBranchSearch = {
    fields?: InputMaybe<Array<FederalStateBranchSearchField>>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export enum FederalStateBranchSearchField {
    Address = 'ADDRESS',
    Id = 'ID',
    Name = 'NAME'
}

export type FederalStateBranchSort = {
    by?: InputMaybe<FederalStateBranchSortField>;
    order?: InputMaybe<SortOrder>;
};

export enum FederalStateBranchSortField {
    Address = 'ADDRESS',
    CreatedAt = 'CREATED_AT',
    CreatedBy = 'CREATED_BY',
    House = 'HOUSE',
    Id = 'ID',
    Name = 'NAME',
    Place = 'PLACE',
    Street = 'STREET',
    UpdatedAt = 'UPDATED_AT',
    UpdatedBy = 'UPDATED_BY',
    Zip = 'ZIP'
}

export type FederalStateBranchUpdateFieldsInput = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    address?: InputMaybe<UpdateAddress>;
    contact?: InputMaybe<UpdateContact>;
    name?: InputMaybe<Scalars['String']['input']>;
    radioactiveObservations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FederalStateBranchUpdateInput = {
    fields: FederalStateBranchUpdateFieldsInput;
    id: Scalars['ID']['input'];
};

export type FederalStateExportInput = {
    filter?: InputMaybe<FederalStateFilter>;
    ids?: InputMaybe<Array<Scalars['ID']['input']>>;
    search?: InputMaybe<FederalStateSearch>;
    sort?: InputMaybe<FederalStateSort>;
};

export type FederalStateFilter = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    editable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FederalStateItem = {
    __typename?: 'FederalStateItem';
    active: Scalars['Boolean']['output'];
    address: Address;
    contact: Contact;
    editable?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    kind?: Maybe<AuthorityKind>;
    modification: Modification;
    name?: Maybe<Scalars['String']['output']>;
    province?: Maybe<Province>;
    r: Scalars['ID']['output'];
    radioactiveObservations?: Maybe<Scalars['Boolean']['output']>;
    readRights?: Maybe<Scalars['Boolean']['output']>;
};

export type FederalStateList = {
    __typename?: 'FederalStateList';
    items: Array<FederalStateItem>;
    total: Scalars['Int']['output'];
};

export type FederalStateListInput = {
    filter?: InputMaybe<FederalStateFilter>;
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<FederalStateSearch>;
    sort?: InputMaybe<FederalStateSort>;
};

export type FederalStateSearch = {
    fields?: InputMaybe<Array<FederalStateSearchField>>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export enum FederalStateSearchField {
    Address = 'ADDRESS',
    Id = 'ID',
    Name = 'NAME'
}

export type FederalStateSort = {
    by?: InputMaybe<FederalStateSortField>;
    order?: InputMaybe<SortOrder>;
};

export enum FederalStateSortField {
    Address = 'ADDRESS',
    CreatedAt = 'CREATED_AT',
    CreatedBy = 'CREATED_BY',
    House = 'HOUSE',
    Id = 'ID',
    Name = 'NAME',
    Place = 'PLACE',
    Street = 'STREET',
    UpdatedAt = 'UPDATED_AT',
    UpdatedBy = 'UPDATED_BY',
    Zip = 'ZIP'
}

export type FederalStateUpdateFieldsInput = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    address?: InputMaybe<UpdateAddress>;
    contact?: InputMaybe<UpdateContact>;
    name?: InputMaybe<Scalars['String']['input']>;
    radioactiveObservations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FederalStateUpdateInput = {
    fields: FederalStateUpdateFieldsInput;
    id: Scalars['ID']['input'];
};

/** Represents the input data for grant an access request. */
export type GrantAccessInput = {
    users: Array<GrantAccessToUserInput>;
};

export type GrantAccessToUserInput = {
    owner: Scalars['Boolean']['input'];
    userId: Scalars['UUID']['input'];
};

export type IdpResource = {
    __typename?: 'IdpResource';
    address?: Maybe<IdpResourceAddress>;
    context: Scalars['InfraContextId']['output'];
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    ty: ContextType;
};

export type IdpResourceAddress = {
    __typename?: 'IdpResourceAddress';
    additional?: Maybe<Scalars['String']['output']>;
    house: Scalars['String']['output'];
    place: Scalars['String']['output'];
    state?: Maybe<Scalars['String']['output']>;
    street: Scalars['String']['output'];
    zip: Scalars['String']['output'];
};

/** IDP user attributes from ELSTER or BundID. */
export type IdpUserAttributes =
    CompanyIdpUserAttributes | PersonalIdpUserAttributes;

export type LaboratoryAccreditationDocumentItem = {
    __typename?: 'LaboratoryAccreditationDocumentItem';
    filename: Scalars['String']['output'];
    id: Scalars['UUID']['output'];
    mimeType: Scalars['String']['output'];
    size: Scalars['Int']['output'];
    url: Scalars['String']['output'];
};

export type LaboratoryAccreditationDocumentRemoveInput = {
    documentId: Scalars['UUID']['input'];
    id: Scalars['ID']['input'];
};

export type LaboratoryAccreditationDocumentUploadInput = {
    file: Scalars['Upload']['input'];
    id: Scalars['ID']['input'];
};

export type LaboratoryCreateFieldsInput = {
    accreditation: Scalars['String']['input'];
    address: CreateAddress;
    comment?: InputMaybe<Scalars['String']['input']>;
    contact: CreateContact;
    flags: LaboratoryFlagsInput;
    name: Scalars['String']['input'];
    paramsValue: Scalars['String']['input'];
    paramsVersion: Scalars['Int']['input'];
};

export type LaboratoryCreateInput = {
    federalState: Scalars['String']['input'];
    fields: LaboratoryCreateFieldsInput;
    parent?: InputMaybe<Scalars['ID']['input']>;
};

export type LaboratoryDetails = {
    __typename?: 'LaboratoryDetails';
    accreditation?: Maybe<Scalars['String']['output']>;
    accreditationDocuments: Array<LaboratoryAccreditationDocumentItem>;
    active: Scalars['Boolean']['output'];
    address: Address;
    branches: Scalars['Int']['output'];
    contact: Contact;
    editable?: Maybe<Scalars['Boolean']['output']>;
    flags: LaboratoryFlags;
    id: Scalars['ID']['output'];
    modification: Modification;
    name?: Maybe<Scalars['String']['output']>;
    params: Array<LaboratoryParams>;
    paramsValue?: Maybe<Scalars['String']['output']>;
    paramsVersion?: Maybe<Scalars['Int']['output']>;
    parent?: Maybe<LaboratoryParentItem>;
    province?: Maybe<Province>;
    r: Scalars['ID']['output'];
    readRights?: Maybe<Scalars['Boolean']['output']>;
};

export type LaboratoryExistsInput = {
    accreditation?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    street?: InputMaybe<Scalars['String']['input']>;
};

export type LaboratoryExportInput = {
    filter?: InputMaybe<LaboratoryFilter>;
    ids?: InputMaybe<Array<Scalars['ID']['input']>>;
    search?: InputMaybe<LaboratorySearch>;
    sort?: InputMaybe<LaboratorySort>;
};

export type LaboratoryFilter = {
    accreditation?: InputMaybe<Scalars['String']['input']>;
    active?: InputMaybe<Scalars['Boolean']['input']>;
    /** `branches` if not set you'll get all laboratories */
    branches?: InputMaybe<Scalars['Boolean']['input']>;
    federalStateId?: InputMaybe<Scalars['Int']['input']>;
    fullname?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    parentId?: InputMaybe<Scalars['ID']['input']>;
    street?: InputMaybe<Scalars['String']['input']>;
};

export type LaboratoryFlags = {
    __typename?: 'LaboratoryFlags';
    accredPhPhChChSample: Scalars['Boolean']['output'];
    accredPhPhChChTests: Scalars['Boolean']['output'];
    microbiologicalSample: Scalars['Boolean']['output'];
    microbiologicalTests: Scalars['Boolean']['output'];
    officiallyApproved: Scalars['Boolean']['output'];
    onSiteParameterSample: Scalars['Boolean']['output'];
    onSiteParameterTests: Scalars['Boolean']['output'];
    otherTests: Scalars['Boolean']['output'];
    radionuclidesSample: Scalars['Boolean']['output'];
    radionuclidesTests: Scalars['Boolean']['output'];
    supplementaryInformation?: Maybe<Scalars['String']['output']>;
    testAreasAdditionalInformation?: Maybe<Scalars['String']['output']>;
};

export type LaboratoryFlagsInput = {
    accredPhPhChChSample: Scalars['Boolean']['input'];
    accredPhPhChChTests: Scalars['Boolean']['input'];
    microbiologicalSample: Scalars['Boolean']['input'];
    microbiologicalTests: Scalars['Boolean']['input'];
    officiallyApproved: Scalars['Boolean']['input'];
    onSiteParameterSample: Scalars['Boolean']['input'];
    onSiteParameterTests: Scalars['Boolean']['input'];
    otherTests: Scalars['Boolean']['input'];
    radionuclidesSample: Scalars['Boolean']['input'];
    radionuclidesTests: Scalars['Boolean']['input'];
    supplementaryInformation?: InputMaybe<Scalars['String']['input']>;
    testAreasAdditionalInformation?: InputMaybe<Scalars['String']['input']>;
};

export type LaboratoryItem = {
    __typename?: 'LaboratoryItem';
    accreditation?: Maybe<Scalars['String']['output']>;
    active: Scalars['Boolean']['output'];
    address: Address;
    branches: Scalars['Int']['output'];
    contact: Contact;
    editable?: Maybe<Scalars['Boolean']['output']>;
    flags: LaboratoryFlags;
    id: Scalars['ID']['output'];
    modification: Modification;
    name?: Maybe<Scalars['String']['output']>;
    params: Array<LaboratoryParams>;
    paramsValue?: Maybe<Scalars['String']['output']>;
    paramsVersion?: Maybe<Scalars['Int']['output']>;
    parent?: Maybe<LaboratoryParentItem>;
    province?: Maybe<Province>;
    r: Scalars['ID']['output'];
    readRights?: Maybe<Scalars['Boolean']['output']>;
};

export type LaboratoryList = {
    __typename?: 'LaboratoryList';
    items: Array<LaboratoryItem>;
    total: Scalars['Int']['output'];
};

export type LaboratoryListInput = {
    filter?: InputMaybe<LaboratoryFilter>;
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<LaboratorySearch>;
    sort?: InputMaybe<LaboratorySort>;
};

export type LaboratoryParamCode = {
    __typename?: 'LaboratoryParamCode';
    name?: Maybe<Scalars['String']['output']>;
    shapthParameter: Scalars['Int']['output'];
};

export type LaboratoryParamGroup = {
    __typename?: 'LaboratoryParamGroup';
    key: Scalars['String']['output'];
    name?: Maybe<Scalars['String']['output']>;
};

export type LaboratoryParamSubGroup = {
    __typename?: 'LaboratoryParamSubGroup';
    codes: Array<LaboratoryParamCode>;
    key: Scalars['String']['output'];
    name?: Maybe<Scalars['String']['output']>;
};

export type LaboratoryParams = {
    __typename?: 'LaboratoryParams';
    group: LaboratoryParamGroup;
    subGoups: Array<LaboratoryParamSubGroup>;
};

export type LaboratoryParentItem = {
    __typename?: 'LaboratoryParentItem';
    id?: Maybe<Scalars['ID']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    r?: Maybe<Scalars['ID']['output']>;
};

export type LaboratoryRemoveInput = {
    ids: Array<Scalars['ID']['input']>;
};

export type LaboratorySearch = {
    fields?: InputMaybe<Array<LaboratorySearchField>>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export enum LaboratorySearchField {
    Address = 'ADDRESS',
    Id = 'ID',
    Name = 'NAME'
}

export type LaboratorySort = {
    by?: InputMaybe<LaboratorySortField>;
    order?: InputMaybe<SortOrder>;
};

export enum LaboratorySortField {
    Address = 'ADDRESS',
    Branches = 'BRANCHES',
    CreatedAt = 'CREATED_AT',
    CreatedBy = 'CREATED_BY',
    House = 'HOUSE',
    Id = 'ID',
    Name = 'NAME',
    Place = 'PLACE',
    Street = 'STREET',
    UpdatedAt = 'UPDATED_AT',
    UpdatedBy = 'UPDATED_BY',
    Zip = 'ZIP'
}

export type LaboratoryUpdateFieldsInput = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    address?: InputMaybe<UpdateAddress>;
    contact?: InputMaybe<UpdateContact>;
    flags?: InputMaybe<LaboratoryUpdateFlags>;
    name?: InputMaybe<Scalars['String']['input']>;
    paramsValue?: InputMaybe<Scalars['String']['input']>;
    paramsVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type LaboratoryUpdateFlags = {
    accredPhPhChChSample?: InputMaybe<Scalars['Boolean']['input']>;
    accredPhPhChChTests?: InputMaybe<Scalars['Boolean']['input']>;
    microbiologicalSample?: InputMaybe<Scalars['Boolean']['input']>;
    microbiologicalTests?: InputMaybe<Scalars['Boolean']['input']>;
    officiallyApproved?: InputMaybe<Scalars['Boolean']['input']>;
    onSiteParameterSample?: InputMaybe<Scalars['Boolean']['input']>;
    onSiteParameterTests?: InputMaybe<Scalars['Boolean']['input']>;
    otherTests?: InputMaybe<Scalars['Boolean']['input']>;
    radionuclidesSample?: InputMaybe<Scalars['Boolean']['input']>;
    radionuclidesTests?: InputMaybe<Scalars['Boolean']['input']>;
    supplementaryInformation?: InputMaybe<Scalars['String']['input']>;
    testAreasAdditionalInformation?: InputMaybe<Scalars['String']['input']>;
};

export type LaboratoryUpdateInput = {
    fields: LaboratoryUpdateFieldsInput;
    id: Scalars['ID']['input'];
};

/** Filter for list queries. */
export type ListFilter = {
    /** Items per page limit. */
    limit?: InputMaybe<Scalars['Int']['input']>;
    /** Page number. */
    page?: InputMaybe<Scalars['Int']['input']>;
};

export type Modification = {
    __typename?: 'Modification';
    created: ModificationInfo;
    deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
    updated: ModificationInfo;
};

export type ModificationActorInfo =
    ModificationApiClientInfo | ModificationIdInfo | ModificationUserInfo;

export type ModificationApiClientInfo = {
    __typename?: 'ModificationApiClientInfo';
    entity?: Maybe<ModificationEntityInfo>;
    id?: Maybe<Scalars['UUID']['output']>;
};

export type ModificationEntityInfo = {
    __typename?: 'ModificationEntityInfo';
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    r?: Maybe<Scalars['ID']['output']>;
    ty: Scalars['String']['output'];
};

export type ModificationIdInfo = {
    __typename?: 'ModificationIdInfo';
    id?: Maybe<Scalars['UUID']['output']>;
};

export type ModificationInfo = {
    __typename?: 'ModificationInfo';
    at?: Maybe<Scalars['DateTime']['output']>;
    by: ModificationActorInfo;
};

export type ModificationUserInfo = {
    __typename?: 'ModificationUserInfo';
    email?: Maybe<Scalars['String']['output']>;
    entity?: Maybe<ModificationEntityInfo>;
    fullname?: Maybe<Scalars['String']['output']>;
    group?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['UUID']['output']>;
    username?: Maybe<Scalars['String']['output']>;
};

export type MonitoringPlanDraftContext = {
    id?: InputMaybe<Scalars['MonitoringPlanDraftId']['input']>;
    institution?: InputMaybe<Scalars['InstitutionId']['input']>;
    organization?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** monitoring plan draft create input object */
export type MonitoringPlanDraftCreateInput = {
    state: Scalars['JSON']['input'];
};

export type MonitoringPlanDraftDetails = {
    __typename?: 'MonitoringPlanDraftDetails';
    createdAt: Scalars['DateTime']['output'];
    id?: Maybe<Scalars['MonitoringPlanDraftId']['output']>;
    modifiedAt: Scalars['DateTime']['output'];
    state: Scalars['JSON']['output'];
};

/** monitoring plan draft input object */
export type MonitoringPlanDraftInput = {
    state: Scalars['JSON']['input'];
};

export type MonitoringPlanDraftItem = {
    __typename?: 'MonitoringPlanDraftItem';
    createdAt: Scalars['DateTime']['output'];
    hdpName: Scalars['String']['output'];
    id?: Maybe<Scalars['MonitoringPlanDraftId']['output']>;
    modifiedAt: Scalars['DateTime']['output'];
    status: Scalars['String']['output'];
    system: Scalars['String']['output'];
    title: Scalars['String']['output'];
    valid: Scalars['Boolean']['output'];
    validFrom?: Maybe<Scalars['DateTime']['output']>;
    validUntil?: Maybe<Scalars['DateTime']['output']>;
    wspName: Scalars['String']['output'];
};

export type MonitoringPlanDraftList = {
    __typename?: 'MonitoringPlanDraftList';
    items: Array<MonitoringPlanDraftItem>;
    limit?: Maybe<Scalars['Int']['output']>;
    page?: Maybe<Scalars['Int']['output']>;
    total?: Maybe<Scalars['Int']['output']>;
};

export type MonitoringPlanDraftListInput = {
    filter?: InputMaybe<ListFilter>;
    sort?: InputMaybe<MonitoringPlanDraftSort>;
};

export type MonitoringPlanDraftRemoveInput = {
    ids: Array<Scalars['MonitoringPlanDraftId']['input']>;
};

export enum MonitoringPlanDraftScope {
    Hdp = 'HDP',
    Wsp = 'WSP'
}

export type MonitoringPlanDraftSort = {
    by?: InputMaybe<MonitoringPlanDraftSortField>;
    order?: InputMaybe<SortOrder>;
};

export enum MonitoringPlanDraftSortField {
    CreatedAt = 'CREATED_AT',
    HdpName = 'HDP_NAME',
    Status = 'STATUS',
    System = 'SYSTEM',
    TestPeriod = 'TEST_PERIOD',
    Title = 'TITLE',
    WspName = 'WSP_NAME'
}

/** monitoring plan draft update input object */
export type MonitoringPlanDraftUpdateInput = {
    id: Scalars['MonitoringPlanDraftId']['input'];
    state: Scalars['JSON']['input'];
};

/** monitoring plan */
export type MonitoringPlanItem = {
    __typename?: 'MonitoringPlanItem';
    hdp?: Maybe<Named>;
    id?: Maybe<Scalars['MonitoringPlanId']['output']>;
    ident?: Maybe<Scalars['String']['output']>;
    programs: Array<Counted>;
    programsCount?: Maybe<Scalars['Int']['output']>;
    receivedAt?: Maybe<Scalars['DateTime']['output']>;
    sentAt?: Maybe<Scalars['DateTime']['output']>;
    site?: Maybe<Site>;
    status?: Maybe<Scalars['String']['output']>;
    title: Scalars['String']['output'];
    uploadedAt: Scalars['DateTime']['output'];
    url?: Maybe<Scalars['String']['output']>;
    wsp?: Maybe<Named>;
    years?: Maybe<Array<Scalars['Int']['output']>>;
};

export type MonitoringPlanList = {
    __typename?: 'MonitoringPlanList';
    items: Array<MonitoringPlanItem>;
    limit?: Maybe<Scalars['Int']['output']>;
    page?: Maybe<Scalars['Int']['output']>;
    total?: Maybe<Scalars['Int']['output']>;
};

export type MonitoringPlanListInput = {
    filter?: InputMaybe<ListFilter>;
    sort?: InputMaybe<MonitoringPlanSort>;
};

export type MonitoringPlanRemoveInput = {
    ids: Array<Scalars['MonitoringPlanId']['input']>;
};

export enum MonitoringPlanScope {
    Hdp = 'HDP',
    Wsp = 'WSP'
}

export type MonitoringPlanSort = {
    by?: InputMaybe<MonitoringPlanSortField>;
    order?: InputMaybe<SortOrder>;
};

export enum MonitoringPlanSortField {
    Hdp = 'HDP',
    Ident = 'IDENT',
    Programs = 'PROGRAMS',
    ProgramsCount = 'PROGRAMS_COUNT',
    ReceivedAt = 'RECEIVED_AT',
    SentAt = 'SENT_AT',
    Site = 'SITE',
    Status = 'STATUS',
    Title = 'TITLE',
    UploadedAt = 'UPLOADED_AT',
    Wsp = 'WSP',
    Years = 'YEARS'
}

/** Monitoring plan status values exposed in GraphQL. */
export enum MonitoringPlanStatus {
    InCreation = 'IN_CREATION',
    Rejected = 'REJECTED',
    Released = 'RELEASED',
    RequestedByOperator = 'REQUESTED_BY_OPERATOR',
    RequestedByWsp = 'REQUESTED_BY_WSP',
    ToBeCompletedByOperator = 'TO_BE_COMPLETED_BY_OPERATOR'
}

export type Mutation = {
    __typename?: 'Mutation';
    /**
     * Creates an authority.
     *
     * # Arguments:
     * - `input` – Core authority data, such as name, address, contact information, etc.
     *
     * # Returns:
     * - The created authority object
     *
     * **Permissions Required:**
     * - `health_department:manage`
     * - `customer` or `organization` context
     */
    authorityCreate: AuthorityItem;
    /**
     * Removes multiple authorities by their IDs.
     *
     * # Arguments:
     * - `input` – Parameters required to delete authorities:
     * - `ids` – A list of authority IDs to delete
     *
     * # Returns:
     * - Number of authorities removed.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `admin` role
     */
    authorityRemove: Scalars['Int']['output'];
    /**
     * Updates an existing authority's data.
     *
     * # Arguments:
     * - `input` – Updated authority data, such as name, address, contact information, etc.
     *
     * # Returns:
     * - The updated authority object
     *
     * **Permissions Required:**
     * - `health_department:update`
     */
    authorityUpdate: AuthorityItem;
    /**
     * Denies one or more pending access requests.
     *
     * Updates the state of the specified access requests to "denied". Only the owner of the
     * requested entity (or an admin) may deny — e.g. a request targeted at Wsp/WspB cannot be
     * denied by Olb/OlbB actors.
     *
     * # Arguments:
     * - `input` — DenyAccessInput with the users whose access requests are denied
     *
     * # Returns:
     * - The number of requests successfully denied
     *
     * **Permissions Required:**
     * - Update permission for the applicable resource type (e.g., `health_department:update`,
     * `laboratory:update`, etc.) and the user update permission
     */
    denyAccess: Scalars['Int']['output'];
    /**
     * Updates an existing federal state branch's data.
     *
     * # Arguments:
     * - `input` – Updated federal state branch data, such as name, address, contact information, etc.
     *
     * # Returns:
     * - The updated federal state branch object
     *
     * **Permissions Required:**
     * - `federal_state:update`
     * - `customer` or `organization` context
     */
    federalStateBranchUpdate: FederalStateBranchItem;
    /**
     * Updates an existing federal state's data.
     *
     * # Arguments:
     * - `input` – Updated federal state data, such as name, address, contact information, etc.
     *
     * # Returns:
     * - The updated federal state object
     *
     * **Permissions Required:**
     * - `federal_state:update`
     * - `customer` context
     */
    federalStateUpdate: FederalStateItem;
    /**
     * Grants one or more access requests.
     *
     * This mutation updates the state of the specified access requests to "granted".
     *
     * # Arguments:
     * - `input` — GrantAccessInput containing a list of the user_id and if the user is gets owner permissions or not
     *
     * # Returns:
     * - The number of requests successfully granted
     *
     * **Permissions Required:**
     * - Update permission for the applicable resource type (e.g., `health_department:update`,
     * `laboratory:update`, etc.) and the user update permission
     */
    grantAccess: Scalars['Int']['output'];
    /**
     * Removes a laboratory accreditation document by its ID.
     *
     * # Arguments:
     * - `input` — Parameters for removal of accredation documents
     * - `id` — ID of the laboratory to which the documents belong
     * - `document` — ID of the laboratory accreditation Document to remove
     *
     * # Returns:
     * - Number of laboratories removed.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `laboratory:manage`
     */
    laboratoryAccreditationDocumentRemove: Scalars['Boolean']['output'];
    /**
     * Uploads one accreditation document for a laboratory.
     *
     * # Arguments:
     * - `input` — Parameters for the document upload:
     * - `id` — ID of the laboratory to which the documents belong
     * - `file` — File to be uploaded
     *
     * # Returns:
     * - The newly stored document metadata
     *
     * **Permissions Required:**
     * - `laboratory:manage`
     * - `customer` context
     */
    laboratoryAccreditationDocumentUpload: LaboratoryAccreditationDocumentItem;
    /**
     * Creates a laboratory.
     *
     * # Arguments:
     * - `input` – Core laboratory data, such as name, address, contact information, etc.
     *
     * # Returns:
     * - The created laboratory object
     *
     * **Permissions Required:**
     * - `laboratory:manage`
     * - `customer` context
     */
    laboratoryCreate: LaboratoryDetails;
    /**
     * Removes multiple laboratories by their IDs.
     *
     * # Arguments:
     * - `input` – Parameters required to delete laboratories:
     * - `ids` – A list of laboratory IDs to delete
     *
     * # Returns:
     * - Number of laboratories removed.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `laboratory:manage`
     */
    laboratoryRemove: Scalars['Int']['output'];
    /**
     * Updates an existing laboratory's data.
     *
     * # Arguments:
     * - `input` – Updated laboratory data, such as name, address, contact information, etc.
     *
     * # Returns:
     * - The updated laboratory object
     *
     * **Permissions Required:**
     * - `laboratory:update`
     */
    laboratoryUpdate: LaboratoryDetails;
    /**
     * Creates a draft of monitoring plan.
     *
     * # Arguments:
     * - `input` — The draft create input to save (see [`MonitoringPlanDraftCreateInput`])
     *
     * # Returns:
     * - The created monitoring plan draft if successful; otherwise `None`
     *
     * **Permissions Required:**
     * - `monitoring_plan:update`
     * - And resource access
     */
    monitoringPlanDraftCreate: MonitoringPlanDraftItem;
    /**
     * Removes monitoring plan drafts by their IDs.
     *
     * # Arguments:
     * - `ids` — The IDs of the monitoring plan drafts to delete
     *
     * # Returns:
     * - The number of monitoring plan drafts removed
     *
     * **Permissions Required:**
     * - `monitoring_plan:delete`
     * - And resource access
     */
    monitoringPlanDraftRemove: Scalars['Int']['output'];
    /**
     * Updates a draft of monitoring plan.
     *
     * # Arguments:
     * - `input` — The draft update input to save (see [`MonitoringPlanDraftUpdateInput`])
     *
     * # Returns:
     * - The created monitoring plan draft if successful; otherwise `None`
     *
     * **Permissions Required:**
     * - `monitoring_plan:update`
     * - And resource access
     */
    monitoringPlanDraftUpdate: MonitoringPlanDraftItem;
    /**
     * Removes multiple monitoring plans by their IDs.
     *
     * # Arguments:
     * - `ids` — The IDs of the monitoring plans to delete
     *
     * # Returns:
     * - The number of monitoring plans removed
     *
     * **Permissions Required:**
     * - `monitoring_plan:delete`
     * - And resource access
     */
    monitoringPlanRemove: Scalars['Int']['output'];
    /**
     * Removes multiple water supplier quality reports by their IDs.
     *
     * # Arguments:
     * - `input` — The RemoveInput Object
     * -     `ids` — The IDs of the quality reports to delete
     *
     * # Returns:
     * - The number of reports removed
     *
     * **Permissions Required:**
     * - `quality_report:delete`
     * - And resource access
     */
    qualityReportRemove: Scalars['Int']['output'];
    /**
     * Sends multiple water supplier quality reports by their IDs.
     *
     * # Arguments:
     * - `input` — The SendInput Object
     * -     `ids` — The IDs of the water supplier quality reports to send
     *
     * # Returns:
     * - The number of reports sent
     *
     * **Permissions Required:**
     * - `quality_report:update`
     * - And `wsp` resource access
     */
    qualityReportSend: QualityReportSent;
    /**
     * Removes multiple monitoring plan drafts by their IDs.
     *
     * ⚠️ **Planned deprecation**
     * This mutation is planned to be deprecated in a future release.
     * The functionality will be re-implemented in `qualityReportRemove`.
     *
     * # Arguments:
     * - `ids` — The IDs of the monitoring plan drafts to delete
     *
     * # Returns:
     * - The number of monitoring plan drafts removed
     *
     * **Permissions Required:**
     * - `monitoring_plan:delete`
     * - And resource access
     */
    removeMonitoringPlanDrafts: Scalars['Int']['output'];
    /**
     * Removes multiple monitoring plans by their IDs.
     *
     * ⚠️ **Planned deprecation**
     * This mutation is planned to be deprecated in a future release.
     * The functionality will be re-implemented in `monitoringPlanRemove`.
     *
     * # Arguments:
     * - `ids` — The IDs of the monitoring plans to delete
     *
     * # Returns:
     * - The number of monitoring plans removed
     *
     * **Permissions Required:**
     * - `monitoring_plan:delete`
     * - And resource access
     */
    removeMonitoringPlans: Scalars['Int']['output'];
    /**
     * Removes multiple water supplier quality reports by their IDs.
     *
     * ⚠️ **Planned deprecation**
     * This mutation is planned to be deprecated in a future release.
     * The functionality will be re-implemented in `qualityReportRemove`.
     *
     * # Arguments:
     * - `ids` — The IDs of the quality reports to delete
     *
     * # Returns:
     * - The number of reports removed
     *
     * **Permissions Required:**
     * - `quality_report:delete`
     * - And resource access
     */
    removeQualityReports: Scalars['Int']['output'];
    /**
     * Requests access to a resource (e.g., health department, laboratory, etc.).
     *
     * This mutation allows a user (with `applicant` role) to request access to a specific resource.
     * The request is stored in Keycloak user attributes and awaits approval by the resource owner.
     *
     * # Arguments:
     * - `input` — Resource details and additional user attributes for the request:
     * - `resource_id` — The ID of the resource being accessed
     * - `attributes` — Optional additional attributes provided by the user
     *
     * # Returns:
     * - `true` if the request was successfully created; otherwise an error
     *
     * **Permissions Required:**
     * - `applicant` role
     */
    requestAccess: Scalars['Boolean']['output'];
    /**
     * Saves a draft of monitoring plan.
     *
     * ⚠️ **Planned deprecation**
     * This mutation is planned to be deprecated in a future release.
     * The functionality will be re-implemented in `monitoringPlanDraftCreate` and `monitoringPlanDraftUpdate`.
     *
     * # Arguments:
     * - `context` — The context of the monitoring plan draft (see [`MonitoringPlanDraftContext`])
     * - `input` — The draft input to save (see [`MonitoringPlanDraftInput`])
     *
     * # Returns:
     * - The saved monitoring plan draft if successful; otherwise `None`
     *
     * **Permissions Required:**
     * - `monitoring_plan:update`
     * - And resource access
     */
    saveMonitoringPlanDraft?: Maybe<MonitoringPlanDraftItem>;
    /**
     * Sends multiple water supplier quality reports by their IDs.
     *
     * ⚠️ **Planned deprecation**
     * This mutation is planned to be deprecated in a future release.
     * The functionality will be re-implemented in `qualityReportSend`.
     *
     * # Arguments:
     * - `ids` — The IDs of the water supplier quality reports to send
     *
     * # Returns:
     * - The number of reports sent
     *
     * **Permissions Required:**
     * - `quality_report:update`
     * - And `wsp` resource access
     */
    sendQualityReports: SendQualityReports;
    /**
     * Updates the notification settings for the currently authenticated user.
     *
     * Returns the updated settings after persisting.
     */
    updateNotificationSettings: NotificationSettings;
    /**
     * Creates a water supplier.
     *
     * # Arguments:
     * - `input` – Core water supplier data, such as address, contact information, etc.
     *
     * # Returns:
     * - The created water supplier object
     *
     * **Permissions Required:**
     * - `admin` or `applicant` role
     */
    waterSupplierCreate: WaterSupplierItem;
    /**
     * Grants read access to a water supplier.
     *
     * This mutation assigns read permissions to the specified readers
     * for a particular water supplier, enabling to view its data.
     *
     * # Arguments:
     * - `input` – Parameters required to grant read access:
     * - `id` – The ID of the water supplier that should be shared
     * - `reader` – A list of reader IDs to grant read access to
     *
     * # Returns:
     * - The number of readers that were successfully granted access.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `water_supplier:update`
     */
    waterSupplierReaderCreate: Scalars['Int']['output'];
    /**
     * Revokes read access to a water supplier.
     *
     * This mutation removes read permissions from the specified readers
     * for a particular water supplier, preventing them from viewing its data.
     *
     * # Arguments:
     * - `input` – Parameters required to revoke read access:
     * - `id` – The ID of the water supplier whose access is being revoked
     * - `reader` – A list of reader IDs whose read access should be revoked
     *
     * # Returns:
     * - The number of readers whose access was successfully revoked.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `water_supplier:update`
     */
    waterSupplierReaderRemove: Scalars['Int']['output'];
    /**
     * Removes multiple water suppliers by their IDs.
     *
     * # Arguments:
     * - `input` – Parameters required to delete water suppliers:
     * - `ids` – A list of water supplier IDs to delete
     *
     * # Returns:
     * - Number of water suppliers removed.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `water_supplier:manage`
     * - `organization` or `institution` context
     */
    waterSupplierRemove: Scalars['Int']['output'];
    /**
     * Updates an existing water supplier's data.
     *
     * # Arguments:
     * - `input` – Updated water supplier data, such as address, contact information, etc.
     *
     * # Returns:
     * - The updated water supplier object
     *
     * **Permissions Required:**
     * - `water_supplier:update`
     * - `organization` or `institution` context
     */
    waterSupplierUpdate: WaterSupplierItem;
    /**
     * Creates a WS area.
     *
     * # Arguments:
     * - `input` – Core WS area data, such as name, location, authority association,
     * and other relevant fields
     *
     * # Returns:
     * - The created WS area
     *
     * **Permissions Required:**
     * - `ws_area:manage`
     */
    wsAreaCreate: WsAreaDetails;
    /**
     * Grants read access to a WS area.
     *
     * This mutation assigns read permissions to the specified readers
     * for a particular WS area, enabling to view its data.
     *
     * # Arguments:
     * - `input` – Parameters required to grant read access:
     * - `id` – The ID of the WS area that should be shared
     * - `reader` – A list of reader IDs to grant read access to
     * - `exclusive` – Whether to revoke read access from all other readers before granting new ones
     *
     * # Returns:
     * - The number of readers that were successfully granted access.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `ws_area_rr:manage`
     */
    wsAreaReaderCreate: Scalars['Int']['output'];
    /**
     * Revokes read access to a WS area.
     *
     * This mutation removes read permissions from the specified readers
     * for a particular WS area, preventing them from viewing its data.
     *
     * # Arguments:
     * - `input` – Parameters required to revoke read access:
     * - `id` – The ID of the WS area whose access is being revoked
     * - `reader` – A list of reader IDs whose read access should be revoked
     *
     * # Returns:
     * - The number of readers whose access was successfully revoked.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `ws_area_rr:manage`
     */
    wsAreaReaderRemove: Scalars['Int']['output'];
    /**
     * Removes multiple WS areas by their IDs.
     *
     * # Arguments:
     * - `input` – Parameters required to delete WS areas:
     * - `ids` – A list of WS area IDs to delete
     *
     * # Returns:
     * - Number of WS areas removed.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `administration`
     */
    wsAreaRemove: Scalars['Int']['output'];
    /**
     * Requests read access to a WS area.
     *
     * # Arguments:
     * - `id` – The ID of the WS area for which read access is being requested
     *
     * # Returns:
     * - `true` if the request was submitted, otherwise an error
     *
     * **Permissions Required:**
     * - `wsp`
     */
    wsAreaRequestReadRight: Scalars['Boolean']['output'];
    /**
     * Updates an existing WS area's data.
     *
     * # Arguments:
     * - `input` – Updated WS area data, such as name, location, and other relevant fields
     *
     * # Returns:
     * - The updated WS area
     *
     * **Permissions Required:**
     * - `ws_area:manage`
     */
    wsAreaUpdate: WsAreaDetails;
    /**
     * Updates write access for a WS area.
     *
     * This mutation updates the writer assigned to a particular WS area,
     * replacing the current writer with the specified next one.
     *
     * # Arguments:
     * - `input` – Parameters required to update write access:
     * - `id` – The ID of the WS area whose write access should be updated
     * - `current` – The ID of the writer that currently has write access
     * - `next` – The ID of the writer that should be granted write access
     *
     * # Returns:
     * - `true` if the update was applied, otherwise an error
     *
     * **Permissions Required:**
     * - `ws_area_rr:manage`
     * - `hdp`
     * - `owner` role
     */
    wsAreaWriterUpdate: Scalars['Boolean']['output'];
    /**
     * Creates a WS entity import.
     *
     * # Arguments:
     * - `input` – Core WS entity import data, such as name, file (.ods, .xls, .xlsx),
     * and other relevant fields
     *
     * # Returns:
     * - The created WS entity import
     *
     * **Permissions Required:**
     * - `ws_area:manage`
     * - `ws_system:manage`
     * - `ws_object:manage`
     * - `ws_sample_point:manage`
     */
    wsEntityImportCreate: WsEntityImportItem;
    /**
     * Removes multiple WS systems by their IDs.
     *
     * # Arguments:
     * - `input` – Parameters required to delete WS systems:
     * - `ids` – A list of WS system IDs to delete
     *
     * # Returns:
     * - Number of WS systems removed.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `administration`
     */
    wsEntityImportRemove: Scalars['Int']['output'];
    /**
     * Starts a WS entity import by id.
     *
     * # Arguments:
     * - `id` – The ws entity import id
     *
     * # Returns:
     * - The updated WS entity import
     *
     * **Permissions Required:**
     * - `ws_area:manage`
     * - `ws_system:manage`
     * - `ws_object:manage`
     * - `ws_sample_point:manage`
     */
    wsEntityImportStart: WsEntityImportItem;
    /**
     * Stops a WS entity import by id.
     *
     * # Arguments:
     * - `id` – The ws entity import id
     *
     * # Returns:
     * - The updated WS entity import
     *
     * **Permissions Required:**
     * - `ws_area:manage`
     * - `ws_system:manage`
     * - `ws_object:manage`
     * - `ws_sample_point:manage`
     */
    wsEntityImportStop: WsEntityImportItem;
    /**
     * Creates a WS object.
     *
     * # Arguments:
     * - `input` – Core WS object data, such as name, location, authority & system association,
     * and other relevant fields
     *
     * # Returns:
     * - The created WS object
     *
     * **Permissions Required:**
     * - `ws_object:manage`
     */
    wsObjectCreate: WsObjectDetails;
    /**
     * Grants read access to a WS object.
     *
     * This mutation assigns read permissions to the specified readers
     * for a particular WS object, enabling to view its data.
     *
     * # Arguments:
     * - `input` – Parameters required to grant read access:
     * - `id` – The ID of the WS object that should be shared
     * - `reader` – A list of reader IDs to grant read access to
     * - `exclusive` – Whether to revoke read access from all other readers before granting new ones
     *
     * # Returns:
     * - The number of readers that were successfully granted access.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `ws_object_rr:manage`
     */
    wsObjectReaderCreate: Scalars['Int']['output'];
    /**
     * Revokes read access to a WS object.
     *
     * This mutation removes read permissions from the specified readers
     * for a particular WS object, preventing them from viewing its data.
     *
     * # Arguments:
     * - `input` – Parameters required to revoke read access:
     * - `id` – The ID of the WS object whose access is being revoked
     * - `reader` – A list of reader IDs whose read access should be revoked
     *
     * # Returns:
     * - The number of readers whose access was successfully revoked.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `ws_object_rr:manage`
     */
    wsObjectReaderRemove: Scalars['Int']['output'];
    /**
     * Updates read access for a WS object.
     *
     * This mutation updates the set of readers for a particular WS object,
     * modifying existing read permissions according to the provided input.
     *
     * # Arguments:
     * - `input` – Parameters required to update read access:
     * - `id` – The ID of the WS object whose read access should be updated
     * - `reader` – The ID of the reader that should have read access
     * - `exclusive` – Whether to revoke read access from all other readers
     *
     * # Returns:
     * - `true` if the read access was successfully updated, `false` otherwise.
     *
     * **Permissions Required:**
     * - `ws_object_rr:manage`
     */
    wsObjectReaderUpdate: Scalars['Boolean']['output'];
    /**
     * Release an existing WS object for officials.
     *
     * # Arguments:
     * - `id` – ID of WS object
     *
     * # Returns:
     * - The result if release was successful
     *
     * **Permissions Required:**
     * - `ws_object:manage`
     * - `wsp`
     */
    wsObjectReleaseForOfficial: Scalars['Boolean']['output'];
    /**
     * Removes multiple WS objects by their IDs.
     *
     * # Arguments:
     * - `input` – Parameters required to delete WS objects:
     * - `ids` – A list of WS object IDs to delete
     *
     * # Returns:
     * - Number of WS objects removed.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `administration`
     */
    wsObjectRemove: Scalars['Int']['output'];
    /**
     * Updates an existing WS object's data.
     *
     * # Arguments:
     * - `input` – Updated WS object data, such as name, location, and other relevant fields
     *
     * # Returns:
     * - The updated WS object
     *
     * **Permissions Required:**
     * - `ws_object:manage`
     */
    wsObjectUpdate: WsObjectDetails;
    /**
     * Updates write access for a WS object.
     *
     * This mutation updates the writer assigned to a particular WS object,
     * replacing the current writer with the specified next one.
     *
     * # Arguments:
     * - `input` – Parameters required to update write access:
     * - `id` – The ID of the WS object whose write access should be updated
     * - `current` – The ID of the writer that currently has write access
     * - `next` – The ID of the writer that should be granted write access
     *
     * # Returns:
     * - `true` if the update was applied, otherwise an error
     *
     * **Permissions Required:**
     * - `ws_object_rr:manage`
     * - `hdp`
     * - `owner` role
     */
    wsObjectWriterUpdate: Scalars['Boolean']['output'];
    /**
     * Creates a WS sample point.
     *
     * # Arguments:
     * - `input` – Core WS sample point data, such as name, object & system association,
     * and other relevant fields
     *
     * # Returns:
     * - The created WS sample point
     *
     * **Permissions Required:**
     * - `ws_sample_point:manage`
     */
    wsSamplePointCreate: WsSamplePointItem;
    /**
     * Grants read access to a WS sample point.
     *
     * This mutation assigns read permissions to the specified readers
     * for a particular WS sample point, enabling to view its data.
     *
     * # Arguments:
     * - `input` – Parameters required to grant read access:
     * - `id` – The ID of the WS sample point that should be shared
     * - `reader` – A list of reader IDs to grant read access to
     *
     * # Returns:
     * - The number of readers that were successfully granted access.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `ws_sample_point_rr:manage`
     */
    wsSamplePointReaderCreate: Scalars['Int']['output'];
    /**
     * Revokes read access to a WS sample point.
     *
     * This mutation removes read permissions from the specified readers
     * for a particular WS sample point, preventing them from viewing its data.
     *
     * # Arguments:
     * - `input` – Parameters required to revoke read access:
     * - `id` – The ID of the WS sample point whose access is being revoked
     * - `reader` – A list of reader IDs whose read access should be revoked
     *
     * # Returns:
     * - The number of readers whose access was successfully revoked.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `ws_sample_point_rr:manage`
     */
    wsSamplePointReaderRemove: Scalars['Int']['output'];
    /**
     * Release an existing WS sample point for officials.
     *
     * # Arguments:
     * - `id` – ID of WS sample point
     *
     * # Returns:
     * - The result if release was successful
     *
     * **Permissions Required:**
     * - `ws_sample_point:manage`
     * - `wsp`
     */
    wsSamplePointReleaseForOfficial: Scalars['Boolean']['output'];
    /**
     * Removes multiple WS sample points by their IDs.
     *
     * # Arguments:
     * - `input` – Parameters required to delete WS sample points:
     * - `ids` – A list of WS sample point IDs to delete
     *
     * # Returns:
     * - Number of WS sample points removed.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `administration`
     */
    wsSamplePointRemove: Scalars['Int']['output'];
    /**
     * Updates an existing WS sample point's data.
     *
     * # Arguments:
     * - `input` – Updated WS sample point data, such as name, category, and other relevant fields
     *
     * # Returns:
     * - The updated WS sample point
     *
     * **Permissions Required:**
     * - `ws_sample_point:manage`
     */
    wsSamplePointUpdate: WsSamplePointItem;
    /**
     * Updates write access for a WS sample point.
     *
     * This mutation updates the writer assigned to a particular WS sample point,
     * replacing the current writer with the specified next one.
     *
     * # Arguments:
     * - `input` – Parameters required to update write access:
     * - `id` – The ID of the WS sample point whose write access should be updated
     * - `current` – The ID of the writer that currently has write access
     * - `next` – The ID of the writer that should be granted write access
     *
     * # Returns:
     * - Returns `true` if the update was applied, otherwise `false`.
     *
     * **Permissions Required:**
     * - `ws_sample_point_rr:manage`
     * - `hdp`
     * - `owner` role
     */
    wsSamplePointWriterUpdate: Scalars['Boolean']['output'];
    /**
     * Creates a WS system.
     *
     * # Arguments:
     * - `input` – Core WS system data, such as name, authority & water supplier association,
     * and other relevant fields
     *
     * # Returns:
     * - The created WS system
     *
     * **Permissions Required:**
     * - `ws_system:manage`
     */
    wsSystemCreate: WsSystemDetails;
    /**
     * Creates a WS system.
     *
     * # Arguments:
     * - `input` – Core WS system data, such as name, authority & water supplier association,
     * and other relevant fields
     *
     * # Returns:
     * - The created WS system
     *
     * **Permissions Required:**
     * - `monitoring_plan:update`
     */
    wsSystemMpIdentCreate: Scalars['String']['output'];
    /**
     * Grants read access to a WS system.
     *
     * This mutation assigns read permissions to the specified readers
     * for a particular WS system, enabling to view its data.
     *
     * # Arguments:
     * - `input` – Parameters required to grant read access:
     * - `id` – The ID of the WS system that should be shared
     * - `reader` – A list of reader IDs to grant read access to
     * - `exclusive` – Whether to revoke read access from all other readers
     *
     * # Returns:
     * - The number of readers that were successfully granted access.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `ws_system_rr:manage`
     */
    wsSystemReaderCreate: Scalars['Int']['output'];
    /**
     * Revokes read access to a WS system.
     *
     * This mutation removes read permissions from the specified readers
     * for a particular WS system, preventing them from viewing its data.
     *
     * # Arguments:
     * - `input` – Parameters required to revoke read access:
     * - `id` – The ID of the WS system whose access is being revoked
     * - `reader` – A list of reader IDs whose read access should be revoked
     *
     * # Returns:
     * - The number of readers whose access was successfully revoked.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `ws_system_rr:manage`
     */
    wsSystemReaderRemove: Scalars['Int']['output'];
    /**
     * Updates read access for a WS system.
     *
     * This mutation updates the set of readers for a particular WS system,
     * modifying existing read permissions according to the provided input.
     *
     * # Arguments:
     * - `input` – Parameters required to update read access:
     * - `id` – The ID of the WS system whose read access should be updated
     * - `reader` – The ID of the reader that should have read access
     * - `exclusive` – Whether to revoke read access from all other readers
     *
     * # Returns:
     * - `true` if the read access was successfully updated, `false` otherwise.
     *
     * **Permissions Required:**
     * - `ws_system_rr:manage`
     */
    wsSystemReaderUpdate: Scalars['Boolean']['output'];
    /**
     * Removes multiple WS systems by their IDs.
     *
     * # Arguments:
     * - `input` – Parameters required to delete WS systems:
     * - `ids` – A list of WS system IDs to delete
     *
     * # Returns:
     * - Number of WS systems removed.
     * It is equal to the number of provided IDs if the operation completes successfully.
     *
     * **Permissions Required:**
     * - `administration`
     */
    wsSystemRemove: Scalars['Int']['output'];
    /**
     * Requests read access to a WS system.
     *
     * # Arguments:
     * - `id` – The ID of the WS system for which read access is being requested
     *
     * # Returns:
     * - `true` if the request was submitted, otherwise an error
     *
     * **Permissions Required:**
     * - `wsp`
     */
    wsSystemRequestReadRight: Scalars['Boolean']['output'];
    /**
     * Updates an existing WS system's data.
     *
     * # Arguments:
     * - `input` – Updated WS system data, such as name, kind, and other relevant fields
     *
     * # Returns:
     * - The updated WS system
     *
     * **Permissions Required:**
     * - `ws_system:manage`
     */
    wsSystemUpdate: WsSystemDetails;
    /**
     * Updates write access for a WS system.
     *
     * This mutation updates the writer assigned to a particular WS system,
     * replacing the current writer with the specified next one.
     *
     * # Arguments:
     * - `input` – Parameters required to update write access:
     * - `id` – The ID of the WS system whose write access should be updated
     * - `current` – The ID of the writer that currently has write access
     * - `next` – The ID of the writer that should be granted write access
     *
     * # Returns:
     * - `true` if the update was applied, otherwise an error
     *
     * **Permissions Required:**
     * - `ws_sample_point_rr:manage`
     * - `hdp`
     * - `owner` role
     */
    wsSystemWriterUpdate: Scalars['Boolean']['output'];
};

export type MutationAuthorityCreateArgs = {
    input: AuthorityCreateInput;
};

export type MutationAuthorityRemoveArgs = {
    input: AuthorityRemoveInput;
};

export type MutationAuthorityUpdateArgs = {
    input: AuthorityUpdateInput;
};

export type MutationDenyAccessArgs = {
    input: DenyAccessInput;
};

export type MutationFederalStateBranchUpdateArgs = {
    input: FederalStateBranchUpdateInput;
};

export type MutationFederalStateUpdateArgs = {
    input: FederalStateUpdateInput;
};

export type MutationGrantAccessArgs = {
    input: GrantAccessInput;
};

export type MutationLaboratoryAccreditationDocumentRemoveArgs = {
    input: LaboratoryAccreditationDocumentRemoveInput;
};

export type MutationLaboratoryAccreditationDocumentUploadArgs = {
    input: LaboratoryAccreditationDocumentUploadInput;
};

export type MutationLaboratoryCreateArgs = {
    input: LaboratoryCreateInput;
};

export type MutationLaboratoryRemoveArgs = {
    input: LaboratoryRemoveInput;
};

export type MutationLaboratoryUpdateArgs = {
    input: LaboratoryUpdateInput;
};

export type MutationMonitoringPlanDraftCreateArgs = {
    input: MonitoringPlanDraftCreateInput;
};

export type MutationMonitoringPlanDraftRemoveArgs = {
    input: MonitoringPlanDraftRemoveInput;
};

export type MutationMonitoringPlanDraftUpdateArgs = {
    input: MonitoringPlanDraftUpdateInput;
};

export type MutationMonitoringPlanRemoveArgs = {
    input: MonitoringPlanRemoveInput;
};

export type MutationQualityReportRemoveArgs = {
    input: QualityReportRemoveInput;
};

export type MutationQualityReportSendArgs = {
    input: QualityReportSendInput;
};

export type MutationRemoveMonitoringPlanDraftsArgs = {
    ids: Array<Scalars['MonitoringPlanDraftId']['input']>;
    scope?: InputMaybe<MonitoringPlanDraftScope>;
};

export type MutationRemoveMonitoringPlansArgs = {
    ids: Array<Scalars['MonitoringPlanId']['input']>;
    scope: MonitoringPlanScope;
};

export type MutationRemoveQualityReportsArgs = {
    ids: Array<Scalars['QualityReportId']['input']>;
    scope?: InputMaybe<QualityReportScope>;
};

export type MutationRequestAccessArgs = {
    input: AccessRequestInput;
};

export type MutationSaveMonitoringPlanDraftArgs = {
    context: MonitoringPlanDraftContext;
    input: MonitoringPlanDraftInput;
    scope: MonitoringPlanDraftScope;
};

export type MutationSendQualityReportsArgs = {
    ids: Array<Scalars['QualityReportId']['input']>;
    scope?: InputMaybe<QualityReportScope>;
};

export type MutationUpdateNotificationSettingsArgs = {
    input: UserNotificationSettingsInput;
};

export type MutationWaterSupplierCreateArgs = {
    input: WaterSupplierCreateInput;
};

export type MutationWaterSupplierReaderCreateArgs = {
    input: WaterSupplierReaderInput;
};

export type MutationWaterSupplierReaderRemoveArgs = {
    input: WaterSupplierReaderInput;
};

export type MutationWaterSupplierRemoveArgs = {
    input: WaterSupplierRemoveInput;
};

export type MutationWaterSupplierUpdateArgs = {
    input: WaterSupplierUpdateInput;
};

export type MutationWsAreaCreateArgs = {
    input: WsAreaCreateInput;
};

export type MutationWsAreaReaderCreateArgs = {
    input: WsAreaReaderCreateInput;
};

export type MutationWsAreaReaderRemoveArgs = {
    input: WsAreaReaderRemoveInput;
};

export type MutationWsAreaRemoveArgs = {
    input: WsAreaRemoveInput;
};

export type MutationWsAreaRequestReadRightArgs = {
    id: Scalars['ID']['input'];
};

export type MutationWsAreaUpdateArgs = {
    input: WsAreaUpdateInput;
};

export type MutationWsAreaWriterUpdateArgs = {
    input: WsAreaWriterUpdateInput;
};

export type MutationWsEntityImportCreateArgs = {
    input: WsEntityImportCreateInput;
};

export type MutationWsEntityImportRemoveArgs = {
    input: WsEntityImportRemoveInput;
};

export type MutationWsEntityImportStartArgs = {
    id: Scalars['ID']['input'];
};

export type MutationWsEntityImportStopArgs = {
    id: Scalars['ID']['input'];
};

export type MutationWsObjectCreateArgs = {
    input: WsObjectCreateInput;
};

export type MutationWsObjectReaderCreateArgs = {
    input: WsObjectReaderCreateInput;
};

export type MutationWsObjectReaderRemoveArgs = {
    input: WsObjectReaderRemoveInput;
};

export type MutationWsObjectReaderUpdateArgs = {
    input: WsObjectReaderUpdateInput;
};

export type MutationWsObjectReleaseForOfficialArgs = {
    id: Scalars['ID']['input'];
};

export type MutationWsObjectRemoveArgs = {
    input: WsObjectRemoveInput;
};

export type MutationWsObjectUpdateArgs = {
    input: WsObjectUpdateInput;
};

export type MutationWsObjectWriterUpdateArgs = {
    input: WsObjectWriterUpdateInput;
};

export type MutationWsSamplePointCreateArgs = {
    input: WsSamplePointCreateInput;
};

export type MutationWsSamplePointReaderCreateArgs = {
    input: WsSamplePointReaderCreateInput;
};

export type MutationWsSamplePointReaderRemoveArgs = {
    input: WsSamplePointReaderRemoveInput;
};

export type MutationWsSamplePointReleaseForOfficialArgs = {
    id: Scalars['ID']['input'];
};

export type MutationWsSamplePointRemoveArgs = {
    input: WsSamplePointRemoveInput;
};

export type MutationWsSamplePointUpdateArgs = {
    input: WsSamplePointUpdateInput;
};

export type MutationWsSamplePointWriterUpdateArgs = {
    input: WsSamplePointWriterUpdateInput;
};

export type MutationWsSystemCreateArgs = {
    input: WsSystemCreateInput;
};

export type MutationWsSystemMpIdentCreateArgs = {
    input: WsSystemMpIdentCreateInput;
};

export type MutationWsSystemReaderCreateArgs = {
    input: WsSystemReaderCreateInput;
};

export type MutationWsSystemReaderRemoveArgs = {
    input: WsSystemReaderRemoveInput;
};

export type MutationWsSystemReaderUpdateArgs = {
    input: WsSystemReaderUpdateInput;
};

export type MutationWsSystemRemoveArgs = {
    input: WsSystemRemoveInput;
};

export type MutationWsSystemRequestReadRightArgs = {
    id: Scalars['ID']['input'];
};

export type MutationWsSystemUpdateArgs = {
    input: WsSystemUpdateInput;
};

export type MutationWsSystemWriterUpdateArgs = {
    input: WsSystemWriterUpdateInput;
};

/** Named object. */
export type Named = {
    __typename?: 'Named';
    id?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
};

/**
 * Notification settings for the current user, controlling which email
 * notifications are sent.
 */
export type NotificationSettings = {
    __typename?: 'NotificationSettings';
    monitoringPlanAutoDelete?: Maybe<Scalars['Boolean']['output']>;
    monitoringPlanStatus?: Maybe<Scalars['Boolean']['output']>;
    monitoringPlanStatusSelected: Array<MonitoringPlanStatus>;
    qualityReportAutoDelete?: Maybe<Scalars['Boolean']['output']>;
    qualityReportReceived?: Maybe<Scalars['Boolean']['output']>;
    yearlyReport?: Maybe<Scalars['Boolean']['output']>;
};

export type OfficialExportInput = {
    filter?: InputMaybe<OfficialFilter>;
    ids?: InputMaybe<Array<Scalars['ID']['input']>>;
    search?: InputMaybe<OfficialSearch>;
    sort?: InputMaybe<OfficialSort>;
};

export type OfficialFilter = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    editable?: InputMaybe<Scalars['Boolean']['input']>;
    federalStateBranchId?: InputMaybe<Scalars['Int']['input']>;
    federalStateId?: InputMaybe<Scalars['Int']['input']>;
    kinds?: InputMaybe<Array<AuthorityKind>>;
    lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OfficialItem = {
    __typename?: 'OfficialItem';
    active: Scalars['Boolean']['output'];
    address: Address;
    contact: Contact;
    editable?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    kind?: Maybe<AuthorityKind>;
    modification: Modification;
    name?: Maybe<Scalars['String']['output']>;
    province?: Maybe<Province>;
    r: Scalars['ID']['output'];
    radioactiveObservations?: Maybe<Scalars['Boolean']['output']>;
    readRights?: Maybe<Scalars['Boolean']['output']>;
};

export type OfficialList = {
    __typename?: 'OfficialList';
    items: Array<OfficialItem>;
    total: Scalars['Int']['output'];
};

export type OfficialListInput = {
    filter?: InputMaybe<OfficialFilter>;
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<OfficialSearch>;
    sort?: InputMaybe<OfficialSort>;
};

export type OfficialSearch = {
    fields?: InputMaybe<Array<OfficialSearchField>>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export enum OfficialSearchField {
    Address = 'ADDRESS',
    Id = 'ID',
    Name = 'NAME'
}

export type OfficialSort = {
    by?: InputMaybe<OfficialSortField>;
    order?: InputMaybe<SortOrder>;
};

export enum OfficialSortField {
    Address = 'ADDRESS',
    CreatedAt = 'CREATED_AT',
    CreatedBy = 'CREATED_BY',
    House = 'HOUSE',
    Id = 'ID',
    Name = 'NAME',
    Place = 'PLACE',
    Street = 'STREET',
    UpdatedAt = 'UPDATED_AT',
    UpdatedBy = 'UPDATED_BY',
    Zip = 'ZIP'
}

export type Pagination = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
};

/** IDP user attributes for personal (BundID) users. */
export type PersonalIdpUserAttributes = {
    __typename?: 'PersonalIdpUserAttributes';
    accessState?: Maybe<AccessState>;
    country: Scalars['String']['output'];
    ext?: Maybe<Scalars['String']['output']>;
    gender: Scalars['String']['output'];
    house?: Maybe<Scalars['String']['output']>;
    personalTitle: Scalars['String']['output'];
    phone: Scalars['String']['output'];
    place: Scalars['String']['output'];
    storkQaaLevel: Scalars['String']['output'];
    street?: Maybe<Scalars['String']['output']>;
    zip: Scalars['String']['output'];
};

export type Province = {
    __typename?: 'Province';
    code: Scalars['String']['output'];
    text: Scalars['String']['output'];
};

export type PublicEntityFilter = {
    kinds?: InputMaybe<Array<PublicEntityKind>>;
    types?: InputMaybe<Array<PublicEntityType>>;
};

export type PublicEntityItem = {
    __typename?: 'PublicEntityItem';
    active?: Maybe<Scalars['Boolean']['output']>;
    address?: Maybe<Scalars['String']['output']>;
    email?: Maybe<Array<Scalars['String']['output']>>;
    id?: Maybe<Scalars['ID']['output']>;
    kind: PublicEntityKind;
    name?: Maybe<Scalars['String']['output']>;
    parent?: Maybe<PublicEntityParentItem>;
    r?: Maybe<Scalars['ID']['output']>;
    readRights?: Maybe<Scalars['Boolean']['output']>;
    ty: PublicEntityType;
};

export enum PublicEntityKind {
    Be = 'BE',
    Ga = 'GA',
    La = 'LA',
    Mb = 'MB',
    None = 'NONE',
    Ob = 'OB',
    So = 'SO',
    Wa = 'WA'
}

export type PublicEntityList = {
    __typename?: 'PublicEntityList';
    items: Array<PublicEntityItem>;
    total: Scalars['Int']['output'];
};

export type PublicEntityListInput = {
    filter?: InputMaybe<PublicEntityFilter>;
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<PublicEntitySearch>;
    sort?: InputMaybe<PublicEntitySort>;
};

export type PublicEntityParentItem = {
    __typename?: 'PublicEntityParentItem';
    id?: Maybe<Scalars['ID']['output']>;
    kind: PublicEntityKind;
    name?: Maybe<Scalars['String']['output']>;
    r?: Maybe<Scalars['ID']['output']>;
    ty: PublicEntityType;
};

export type PublicEntitySearch = {
    fields?: InputMaybe<Array<PublicEntitySearchField>>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export enum PublicEntitySearchField {
    Address = 'ADDRESS',
    Id = 'ID',
    Name = 'NAME'
}

export type PublicEntitySort = {
    by?: InputMaybe<PublicEntitySortField>;
    order?: InputMaybe<SortOrder>;
};

export enum PublicEntitySortField {
    Address = 'ADDRESS',
    Id = 'ID',
    Name = 'NAME'
}

export enum PublicEntityType {
    Hdp = 'HDP',
    Lab = 'LAB',
    LabB = 'LAB_B',
    None = 'NONE',
    Olb = 'OLB',
    OlbB = 'OLB_B',
    Wsp = 'WSP',
    WspB = 'WSP_B'
}

/** quality report. */
export type QualityReportItem = {
    __typename?: 'QualityReportItem';
    cst?: Maybe<Named>;
    evaluation?: Maybe<Scalars['String']['output']>;
    hdp: Array<Named>;
    id?: Maybe<Scalars['QualityReportId']['output']>;
    lab?: Maybe<Named>;
    orderNr?: Maybe<Scalars['String']['output']>;
    receivedAt?: Maybe<Scalars['DateTime']['output']>;
    reportId: Scalars['UUID']['output'];
    sent: Scalars['Boolean']['output'];
    sentAt?: Maybe<Scalars['DateTime']['output']>;
    signed: Scalars['Boolean']['output'];
    status?: Maybe<Scalars['String']['output']>;
    timeOfTransmission?: Maybe<Scalars['DateTime']['output']>;
    timeOfValidation?: Maybe<Scalars['DateTime']['output']>;
    title: Scalars['String']['output'];
    uploadedAt: Scalars['DateTime']['output'];
    url?: Maybe<Scalars['String']['output']>;
};

export type QualityReportList = {
    __typename?: 'QualityReportList';
    items: Array<QualityReportItem>;
    limit?: Maybe<Scalars['Int']['output']>;
    page?: Maybe<Scalars['Int']['output']>;
    total?: Maybe<Scalars['Int']['output']>;
};

export type QualityReportListInput = {
    filter?: InputMaybe<ListFilter>;
    sort?: InputMaybe<QualityReportSort>;
};

export type QualityReportRemoveInput = {
    ids: Array<Scalars['QualityReportId']['input']>;
};

export enum QualityReportScope {
    Hdp = 'HDP',
    Lab = 'LAB',
    Wsp = 'WSP'
}

export type QualityReportSendInput = {
    ids: Array<Scalars['QualityReportId']['input']>;
};

export type QualityReportSent = {
    __typename?: 'QualityReportSent';
    failedIds: Array<Scalars['String']['output']>;
    successIds: Array<Scalars['String']['output']>;
};

export type QualityReportSort = {
    by?: InputMaybe<QualityReportSortField>;
    order?: InputMaybe<SortOrder>;
};

export enum QualityReportSortField {
    Cst = 'CST',
    Evaluation = 'EVALUATION',
    Hdp = 'HDP',
    Lab = 'LAB',
    OrderNr = 'ORDER_NR',
    ReceivedAt = 'RECEIVED_AT',
    Sent = 'SENT',
    SentAt = 'SENT_AT',
    Signed = 'SIGNED',
    Status = 'STATUS',
    TimeOfTransmission = 'TIME_OF_TRANSMISSION',
    TimeOfValidation = 'TIME_OF_VALIDATION',
    Title = 'TITLE',
    UploadedAt = 'UPLOADED_AT'
}

export type Query = {
    __typename?: 'Query';
    /**
     * Retrieves a single authority by its ID.
     *
     * # Arguments:
     * - `id` – The ID of the authority
     *
     * # Returns:
     * - The authority matching the given ID
     *
     * **Permissions Required:**
     * - `health_department:view`
     */
    authorityById: AuthorityItem;
    /**
     * Exports data of specified authorities into CSV format.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the export:
     * - `ids` – A list of authority IDs to export
     *
     * # Returns:
     * - The generated CSV file data containing the requested authority information
     *
     * **Permissions Required:**
     * - `health_department:view`
     */
    authorityExport: Csv;
    /**
     * Retrieves a list of authorities based on optional filtering, sorting, and pagination.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the query:
     * - `filter` – Filters to narrow down the authorities returned (see [`AuthorityFilter`])
     * - `sort` – Defines sorting order (see [`AuthoritySort`])
     * - `pagination` – Controls paging of results (see [`Pagination`])
     *
     * # Returns:
     * - Paginated and optionally filtered list of authorities
     *
     * **Permissions Required:**
     * - `health_department:view`
     */
    authorityList: AuthorityList;
    /** Checks whether a user exists with the specified email address. */
    existsByEmail: Scalars['Boolean']['output'];
    /** Checks whether a user exists with the specified username. */
    existsByUsername: Scalars['Boolean']['output'];
    /**
     * Retrieves a federal state branch by its ID.
     *
     * # Arguments:
     * - `id` – The ID of the federal state branch
     *
     * # Returns:
     * - The federal state branch matching the given ID
     *
     * **Permissions Required:**
     * - `federal_state_branch:view`
     */
    federalStateBranchById: FederalStateBranchItem;
    /**
     * Exports data of specified federal state branches into CSV format.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the export:
     * - `ids` – A list of federal state branch IDs to export
     *
     * # Returns:
     * - The generated CSV file data containing the requested federal state branch information
     *
     * **Permissions Required:**
     * - `federal_state_branch:view`
     */
    federalStateBranchExport: Csv;
    /**
     * Retrieves a list of federal state branches based on optional filtering, sorting, and pagination.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the query:
     * - `filter` – Filters to narrow down the federal state branches returned (see [`FederalStateBranchFilter`])
     * - `sort` – Defines sorting order (see [`FederalStateBranchSort`])
     * - `pagination` – Controls paging of results (see [`Pagination`])
     *
     * # Returns:
     * - Paginated and optionally filtered list of federal state branches
     *
     * **Permissions Required:**
     * - `federal_state_branch:view`
     */
    federalStateBranchList: FederalStateBranchList;
    /**
     * Retrieves a federal state by its ID.
     *
     * # Arguments:
     * - `id` – The ID of the federal state
     *
     * # Returns:
     * - The federal state matching the given ID
     *
     * **Permissions Required:**
     * - `federal_state:view`
     */
    federalStateById: FederalStateItem;
    /**
     * Exports data of specified federal states into CSV format.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the export:
     * - `ids` – A list of federal state IDs to export
     *
     * # Returns:
     * - The generated CSV file data containing the requested federal state information
     *
     * **Permissions Required:**
     * - `federal_state:view`
     */
    federalStateExport: Csv;
    /**
     * Retrieves a list of federal states based on optional filtering, sorting, and pagination.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the query:
     * - `filter` – Filters to narrow down the federal states returned (see [`FederalStateFilter`])
     * - `sort` – Defines sorting order (see [`FederalStateSort`])
     * - `pagination` – Controls paging of results (see [`Pagination`])
     *
     * # Returns:
     * - Paginated and optionally filtered list of federal states
     *
     * **Permissions Required:**
     * - `federal_state:view`
     */
    federalStateList: FederalStateList;
    /**
     * Returns the IDP resources (organizations) available for the
     * currently authenticated user's organization.
     */
    idpResources: Array<IdpResource>;
    /**
     * Returns the IDP user attributes (ELSTER/BundID certificate data)
     * for the currently authenticated user.
     */
    idpUserAttributes?: Maybe<IdpUserAttributes>;
    /**
     * Retrieves a laboratory by its ID.
     *
     * # Arguments:
     * - `id` – The ID of the laboratory
     *
     * # Returns:
     * - The laboratory matching the given ID
     *
     * **Permissions Required:**
     * - `laboratory:view`
     */
    laboratoryById: LaboratoryDetails;
    /**
     * Retrieves a list of selected laboratories by their IDs.
     *
     * # Arguments:
     * - `ids` – The IDs of the laboratories requested
     *
     * # Returns:
     * - The laboratories matching the given IDs
     *
     * **Permissions Required:**
     * - `laboratory:view`
     */
    laboratoryByIds: LaboratoryList;
    /**
     * Retrieves the result if a laboratory exists by specific fields.
     *
     * # Arguments:
     * - `input` – The input with some fields of the laboratory
     *
     * # Returns:
     * - If the laboratory matching all given fields
     *
     * **Permissions Required:**
     * - `laboratory:view`
     */
    laboratoryExists: Scalars['Boolean']['output'];
    /**
     * Exports data of specified laboratories into CSV format.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the export:
     * - `ids` – A list of laboratory IDs to export
     *
     * # Returns:
     * - The generated CSV file data containing the requested laboratory information
     *
     * **Permissions Required:**
     * - `laboratory:view`
     */
    laboratoryExport: Csv;
    /**
     * Retrieves a list of laboratories based on optional filtering, sorting, and pagination.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the query:
     * - `filter` – Filters to narrow down the laboratories returned (see [`LaboratoryFilter`])
     * - `sort` – Defines sorting order (see [`LaboratorySort`])
     * - `pagination` – Controls paging of results (see [`Pagination`])
     *
     * # Returns:
     * - Paginated and optionally filtered list of laboratories
     *
     * **Permissions Required:**
     * - `laboratory:view`
     */
    laboratoryList: LaboratoryList;
    /**
     * Returns the currently authenticated user with their notification
     * settings.
     */
    me?: Maybe<User>;
    /**
     * Retrieves a monitoring plan draft by its ID.
     *
     * # Arguments:
     * - `id` — The ID of the monitoring plan draft
     *
     * # Returns:
     * - The monitoring plan draft if found; otherwise `None`
     *
     * **Permissions Required:**
     * - `monitoring_plan:view`
     */
    monitoringPlanById?: Maybe<MonitoringPlanItem>;
    /**
     * Retrieves a monitoring plan draft by its ID.
     *
     * # Arguments:
     * - `id` — The ID of the monitoring plan draft
     *
     * # Returns:
     * - The monitoring plan draft if found; otherwise `None`
     *
     * **Permissions Required:**
     * - `monitoring_plan:view`
     */
    monitoringPlanDraftById?: Maybe<MonitoringPlanDraftDetails>;
    /**
     * Retrieves a list of monitoring plan drafts with optional pagination.
     *
     * # Arguments:
     * - `context` — Optional scope for the query, specifying an organization or institution
     * - `filter` — Optional filters to narrow down the list of draft plans (see [`ListFilter`])
     *
     * # Returns:
     * - Optionally paginated list of monitoring plan drafts
     *
     * **Permissions Required:**
     * - `monitoring_plan:list`
     */
    monitoringPlanDraftList: MonitoringPlanDraftList;
    /**
     * Retrieves a list of monitoring plan drafts with optional pagination.
     *
     * ⚠️ **Planned deprecation**
     * This query is planned to be deprecated in a future release.
     * The functionality will be re-implemented in `monitoringPlanDraftList`.
     *
     * # Arguments:
     * - `context` — Optional scope for the query, specifying an organization or institution
     * - `filter` — Optional filters to narrow down the list of draft plans (see [`ListFilter`])
     *
     * # Returns:
     * - Optionally paginated list of monitoring plan drafts
     *
     * **Permissions Required:**
     * - `monitoring_plan:list`
     */
    monitoringPlanDrafts: MonitoringPlanDraftList;
    /**
     * Retrieves a list of monitoring plans with optional pagination.
     *
     * # Arguments:
     * - `input` — Optional list input
     * - `filter` — Optional filters to narrow down the list of plans (see [`ListFilter`])
     * - `sort` — Optional sorting criteria for the list of plans (see [`MonitoringPlanSort`])
     *
     * # Returns:
     * - Optionally paginated list of monitoring plans
     *
     * **Permissions Required:**
     * - `monitoring_plan:list`
     */
    monitoringPlanList: MonitoringPlanList;
    /**
     * Retrieves a list of monitoring plans with optional pagination.
     *
     * ⚠️ **Planned deprecation**
     * This query is planned to be deprecated in a future release.
     * The functionality will be re-implemented in `monitoringPlanList`.
     *
     * # Arguments:
     * - `input` — Optional scope for the query, specifying an organization or institution
     * - `filter` — Optional filters to narrow down the list of plans (see [`ListFilter`])
     * - `sort` — Optional sorting criteria for the list of plans (see [`MonitoringPlanSort`])
     *
     * # Returns:
     * - Optionally paginated list of monitoring plans
     *
     * **Permissions Required:**
     * - `monitoring_plan:list`
     */
    monitoringPlans: MonitoringPlanList;
    /**
     * Returns the notification settings for the currently authenticated user.
     *
     * These settings control which email notifications the user receives
     * (monitoring plan status changes, quality report received, auto-delete
     * reminders, yearly report received, etc.).
     */
    notificationSettings?: Maybe<NotificationSettings>;
    /**
     * Retrieves a single official by its ID.
     *
     * # Arguments:
     * - `id` – The ID of the official
     *
     * # Returns:
     * - The official matching the given ID
     *
     * **Permissions Required:**
     * - `health_department:view`
     */
    officialById: OfficialItem;
    /**
     * Retrieves a list of selected officials by their IDs.
     *
     * # Arguments:
     * - `ids` – The IDs of the officials requested
     *
     * # Returns:
     * - The official matching the given ID
     *
     * **Permissions Required:**
     * - `health_department:view`
     */
    officialByIds: OfficialList;
    /**
     * Exports data of specified officials into CSV format.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the export:
     * - `ids` – A list of official IDs to export
     *
     * # Returns:
     * - The generated CSV file data containing the requested official information
     *
     * **Permissions Required:**
     * - `health_department:view`
     */
    officialExport: Csv;
    /**
     * Retrieves a list of officials based on optional filtering, sorting, and pagination.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the query:
     * - `filter` – Filters to narrow down the officials returned (see [`OfficialFilter`])
     * - `sort` – Defines sorting order (see [`OfficialSort`])
     * - `pagination` – Controls paging of results (see [`Pagination`])
     *
     * # Returns:
     * - Paginated and optionally filtered list of officials
     *
     * **Permissions Required:**
     * - `health_department:view`
     */
    officialList: OfficialList;
    publicEntityActor?: Maybe<PublicEntityItem>;
    /**
     * Retrieves a list of public entities based on optional filtering.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the query:
     * - `filter` – Filters to narrow down the public entities returned (see [`PublicEntityFilter`])
     *
     * # Returns:
     * - Optionally filtered list of public entities
     *
     * **Permissions Required:**
     * - `health_department:view`
     * - or `applicant` role
     */
    publicEntityList: PublicEntityList;
    /**
     * Retrieves a quality report by its ID.
     *
     * # Arguments:
     * - `id` — The ID of the quality report
     *
     * # Returns:
     * - The quality report if found; otherwise `None`
     *
     * **Permissions Required:**
     * - `quality_report:view`
     */
    qualityReportById?: Maybe<QualityReportItem>;
    /**
     * Retrieves a quality reports by their IDs.
     *
     * # Arguments:
     * - `ids` — The IDs of the quality reports to fetch
     *
     * # Returns:
     * - The quality reports if found;
     *
     * **Permissions Required:**
     * - `quality_report:view`
     */
    qualityReportByIds: Array<QualityReportItem>;
    /**
     * Retrieves a list of quality reports based on optional pagination.
     *
     * # Arguments:
     * - `input` — Optional list input
     * - `filter` — Optional filters to narrow down the list of reports (see [`ListFilter`])
     * - `sort` — Optional sorting criteria for the list of reports (see [`QualityReportSort`])
     *
     * # Returns:
     * - Optionally paginated list of quality reports
     *
     * **Permissions Required:**
     * - `quality_report:list`
     */
    qualityReportList: QualityReportList;
    /**
     * Retrieves a list of quality reports based on optional pagination.
     *
     * ⚠️ **Planned deprecation**
     * This query is planned to be deprecated in a future release.
     * The functionality will be re-implemented in `qualityReportList`.
     *
     * # Arguments:
     * - `context` — Optional scope for the query, specifying an organization or institution
     * - `filter` — Optional filters to narrow down the list of reports (see [`ListFilter`])
     * - `sort` — Optional sorting criteria for the list of reports (see [`QualityReportSort`])
     *
     * # Returns:
     * - Optionally paginated list of quality reports
     *
     * **Permissions Required:**
     * - `quality_report:list`
     */
    qualityReports: QualityReportList;
    /** Retrieves a user by its ID. */
    userById?: Maybe<User>;
    /**
     * Retrieves a list of users with entities based on optional filtering.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the query:
     * - `filter` – Filters to narrow down the public entities returned (see [`UserFilter`])
     *
     * # Returns:
     * - Optionally filtered list of public entities
     *
     * **Permissions Required:**
     * - `user:list`
     */
    userList: UserList;
    /**
     * Retrieves a water supplier by its ID.
     *
     * # Arguments:
     * - `id` – The ID of the water supplier
     *
     * # Returns:
     * - The water supplier matching the given ID
     *
     * **Permissions Required:**
     * - `water_supplier:view`
     */
    waterSupplierById: WaterSupplierItem;
    /**
     * Exports data of specified water suppliers into CSV format.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the export:
     * - `ids` – A list of water supplier IDs to export
     * - `branches` – Include associated branches in the exported data
     *
     * # Returns:
     * - The generated CSV file data containing the requested water supplier information
     *
     * **Permissions Required:**
     * - `water_supplier:view`
     */
    waterSupplierExport: Csv;
    /**
     * Retrieves a list of water suppliers based on optional filtering, sorting, and pagination.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the query:
     * - `filter` – Filters to narrow down the water suppliers returned (see [`WaterSupplierFilter`])
     * - `sort` – Defines sorting order (see [`WaterSupplierSort`])
     * - `pagination` – Controls paging of results (see [`Pagination`])
     *
     * # Returns:
     * - Paginated and optionally filtered list of water suppliers
     *
     * **Permissions Required:**
     * - `water_supplier:view`
     */
    waterSupplierList: WaterSupplierList;
    /**
     * Retrieves a WS area by its ID.
     *
     * # Arguments:
     * - `id` – The ID of the WS area
     *
     * # Returns:
     * - The WS area matching the given ID
     *
     * **Permissions Required:**
     * - `ws_area:view`
     */
    wsAreaById: WsAreaDetails;
    /**
     * Exports data of specified WS areas into CSV format.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the export:
     * - `ids` – A list of WS area IDs to export
     *
     * # Returns:
     * - The generated CSV file data containing the requested WS area information
     *
     * **Permissions Required:**
     * - `ws_area:view`
     */
    wsAreaExport: Csv;
    /**
     * Retrieves a list of WS areas based on optional filtering, sorting, and pagination.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the query:
     * - `filter` – Filters to narrow down the WS areas returned (see [`WsAreaFilter`])
     * - `sort` – Defines sorting order (see [`WsAreaSort`])
     * - `pagination` – Controls paging of results (see [`Pagination`])
     *
     * # Returns:
     * - Paginated and optionally filtered list of WS areas
     *
     * **Permissions Required:**
     * - `ws_area:view`
     */
    wsAreaList: WsAreaList;
    /**
     * Retrieves a list of WS area readers based on optional filtering, sorting, and pagination.
     *
     * # Arguments:
     * - `input` – Parameters to control the query:
     * - `filter` – Filters to narrow down the WS area readers returned (see [`WsAreaReaderFilter`])
     * - `sort` – Defines sorting order (see [`WsAreaReaderSort`])
     * - `pagination` – Controls paging of results (see [`Pagination`])
     *
     * # Returns:
     * - Paginated and optionally filtered list of WS area readers
     *
     * **Permissions Required:**
     * - `ws_area_rr:manage`
     */
    wsAreaReaderList: WsAreaReaderList;
    wsEntityImportActionListById: WsEntityImportActionList;
    /**
     * Retrieves a WS Entity Import by its ID.
     *
     * # Arguments:
     * - `id` – The ID of the WS Entity Import
     *
     * # Returns:
     * - The WS Entity Import matching the given ID
     *
     * **Permissions Required:**
     * - `ws_area:manage`
     * - `ws_system:manage`
     * - `ws_object:manage`
     * - `ws_sample_point:manage`
     */
    wsEntityImportById: WsEntityImportItem;
    /**
     * Retrieves a list of WS Entity imports based on optional filtering, sorting, and pagination.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the query:
     * - `sort` – Defines sorting order (see [`WsEntityImportSort`])
     * - `pagination` – Controls paging of results (see [`Pagination`])
     *
     * # Returns:
     * - Paginated and optionally filtered list of WS systems
     *
     * **Permissions Required:**
     * - `ws_area:manage`
     * - `ws_system:manage`
     * - `ws_object:manage`
     * - `ws_sample_point:manage`
     */
    wsEntityImportList: WsEntityImportList;
    wsEntityImportResultListById: WsEntityImportResultList;
    /**
     * Retrieves a WS object by its ID.
     *
     * # Arguments:
     * - `id` – The ID of the WS object
     *
     * # Returns:
     * - The WS object matching the given ID
     *
     * **Permissions Required:**
     * - `ws_object:view`
     */
    wsObjectById: WsObjectDetails;
    /**
     * Exports data of specified WS objects into CSV format.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the export:
     * - `ids` – A list of WS object IDs to export
     *
     * # Returns:
     * - The generated CSV file data containing the requested WS object information
     *
     * **Permissions Required:**
     * - `ws_object:view`
     */
    wsObjectExport: Csv;
    /**
     * Retrieves a list of WS objects based on optional filtering, sorting, and pagination.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the query:
     * - `filter` – Filters to narrow down the WS objects returned (see [`WsObjectFilter`])
     * - `sort` – Defines sorting order (see [`WsObjectSort`])
     * - `pagination` – Controls paging of results (see [`Pagination`])
     *
     * # Returns:
     * - Paginated and optionally filtered list of WS objects
     *
     * **Permissions Required:**
     * - `ws_object:view`
     */
    wsObjectList: WsObjectList;
    /**
     * Retrieves a list of WS object readers based on optional filtering, sorting, and pagination.
     *
     * # Arguments:
     * - `input` – Parameters to control the query:
     * - `filter` – Filters to narrow down the WS object readers returned (see [`WsObjectReaderFilter`])
     * - `sort` – Defines sorting order (see [`WsObjectReaderSort`])
     * - `pagination` – Controls paging of results (see [`Pagination`])
     *
     * # Returns:
     * - Paginated and optionally filtered list of WS object readers
     *
     * **Permissions Required:**
     * - `ws_object_rr:view`
     */
    wsObjectReaderList: WsObjectReaderList;
    /**
     * Retrieves a WS sample point by its ID.
     *
     * # Arguments:
     * - `id` – The ID of the WS sample point
     *
     * # Returns:
     * - The WS sample point matching the given ID
     *
     * **Permissions Required:**
     * - `ws_sample_point:view`
     */
    wsSamplePointById: WsSamplePointItem;
    /**
     * Exports data of specified WS sample points into CSV format.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the export:
     * - `ids` – A list of WS sample point IDs to export
     *
     * # Returns:
     * - The generated CSV file data containing the requested WS sample point information
     *
     * **Permissions Required:**
     * - `ws_sample_point:view`
     */
    wsSamplePointExport: Csv;
    /**
     * Retrieves a list of WS sample points based on optional filtering, sorting, and pagination.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the query:
     * - `filter` – Filters to narrow down the WS sample points returned (see [`WsSamplePointFilter`])
     * - `sort` – Defines sorting order (see [`WsSamplePointSort`])
     * - `pagination` – Controls paging of results (see [`Pagination`])
     *
     * # Returns:
     * - Paginated and optionally filtered list of WS sample points
     *
     * **Permissions Required:**
     * - `ws_sample_point:view`
     */
    wsSamplePointList: WsSamplePointList;
    /**
     * Retrieves a list of WS sample point readers based on filtering, sorting, and pagination.
     *
     * # Arguments:
     * - `input` – Parameters to control the query:
     * - `filter` – Filters to narrow down the WS sample point readers returned (see [`WsSamplePointReaderFilter`])
     * - `sort` – Defines sorting order (see [`WsSamplePointReaderSort`])
     * - `pagination` – Controls paging of results (see [`Pagination`])
     *
     * # Returns:
     * - Paginated and optionally filtered list of WS sample point readers
     *
     * **Permissions Required:**
     * - `ws_sample_point_rr:manage`
     */
    wsSamplePointReaderList: WsSamplePointReaderList;
    /**
     * Retrieves a WS system by its ID.
     *
     * # Arguments:
     * - `id` – The ID of the WS system
     *
     * # Returns:
     * - The WS system matching the given ID
     *
     * **Permissions Required:**
     * - `ws_system:view`
     */
    wsSystemById: WsSystemDetails;
    /**
     * Exports data of specified WS systems into CSV format.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the export:
     * - `ids` – A list of WS system IDs to export
     *
     * # Returns:
     * - The generated CSV file data containing the requested WS system information
     *
     * **Permissions Required:**
     * - `ws_system:view`
     */
    wsSystemExport: Csv;
    /**
     * Retrieves a list of WS systems based on optional filtering, sorting, and pagination.
     *
     * # Arguments:
     * - `input` – Optional parameters to control the query:
     * - `filter` – Filters to narrow down the WS systems returned (see [`WsSystemFilter`])
     * - `sort` – Defines sorting order (see [`WsSystemSort`])
     * - `pagination` – Controls paging of results (see [`Pagination`])
     *
     * # Returns:
     * - Paginated and optionally filtered list of WS systems
     *
     * **Permissions Required:**
     * - `ws_system:view`
     */
    wsSystemList: WsSystemList;
    /**
     * Retrieves a list of WS system readers based on optional filtering, sorting, and pagination.
     *
     * # Arguments:
     * - `input` – Parameters to control the query:
     * - `filter` – Filters to narrow down the WS system readers returned (see [`WsSystemReaderFilter`])
     * - `sort` – Defines sorting order (see [`WsSystemReaderSort`])
     * - `pagination` – Controls paging of results (see [`Pagination`])
     *
     * # Returns:
     * - Paginated and optionally filtered list of WS system readers
     *
     * **Permissions Required:**
     * - `ws_system_rr:manage`
     */
    wsSystemReaderList: WsSystemReaderList;
    /**
     * Retrieves a yearly report by its ID.
     *
     * # Arguments:
     * - `id` — The ID of the yearly report
     *
     * # Returns:
     * - The yearly report if found; otherwise `None`
     *
     * **Permissions Required:**
     * - `olb_report:view`
     */
    yearlyReportById?: Maybe<YearlyReportItem>;
    /**
     * Retrieves a list of yearly reports based on optional pagination.
     *
     * # Arguments:
     * - `input` - Optional List Input
     * - `filter` — Optional filters to narrow down the list of reports (see [`ListFilter`])
     * - `sort` — Optional sorting criteria for the list of reports (see [`YearlyReportSort`])
     *
     * # Returns:
     * - Optionally paginated list of yearly reports
     *
     * **Permissions Required:**
     * - `olb_report:list`
     */
    yearlyReportList: YearlyReportList;
    /**
     * Retrieves a list of yearly reports based on optional pagination.
     *
     * ⚠️ **Planned deprecation**
     * This query is planned to be deprecated in a future release.
     * The functionality will be re-implemented in `yearlyReportList`.
     *
     * # Arguments:
     * - `context` — Optional scope for the query, specifying an organization or institution
     * - `filter` — Optional filters to narrow down the list of reports (see [`ListFilter`])
     * - `sort` — Optional sorting criteria for the list of reports (see [`YearlyReportSort`])
     *
     * # Returns:
     * - Optionally paginated list of yearly reports
     *
     * **Permissions Required:**
     * - `olb_report:list`
     */
    yearlyReports: YearlyReportList;
};

export type QueryAuthorityByIdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryAuthorityExportArgs = {
    input?: InputMaybe<AuthorityExportInput>;
};

export type QueryAuthorityListArgs = {
    input?: InputMaybe<AuthorityListInput>;
};

export type QueryExistsByEmailArgs = {
    email: Scalars['String']['input'];
};

export type QueryExistsByUsernameArgs = {
    username: Scalars['String']['input'];
};

export type QueryFederalStateBranchByIdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryFederalStateBranchExportArgs = {
    input?: InputMaybe<FederalStateBranchExportInput>;
};

export type QueryFederalStateBranchListArgs = {
    input?: InputMaybe<FederalStateBranchListInput>;
};

export type QueryFederalStateByIdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryFederalStateExportArgs = {
    input?: InputMaybe<FederalStateExportInput>;
};

export type QueryFederalStateListArgs = {
    input?: InputMaybe<FederalStateListInput>;
};

export type QueryLaboratoryByIdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryLaboratoryByIdsArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type QueryLaboratoryExistsArgs = {
    input: LaboratoryExistsInput;
};

export type QueryLaboratoryExportArgs = {
    input?: InputMaybe<LaboratoryExportInput>;
};

export type QueryLaboratoryListArgs = {
    input?: InputMaybe<LaboratoryListInput>;
};

export type QueryMonitoringPlanByIdArgs = {
    id: Scalars['MonitoringPlanId']['input'];
    scope?: InputMaybe<MonitoringPlanScope>;
};

export type QueryMonitoringPlanDraftByIdArgs = {
    id: Scalars['MonitoringPlanDraftId']['input'];
    scope?: InputMaybe<MonitoringPlanDraftScope>;
};

export type QueryMonitoringPlanDraftListArgs = {
    input?: InputMaybe<MonitoringPlanDraftListInput>;
};

export type QueryMonitoringPlanDraftsArgs = {
    input?: InputMaybe<MonitoringPlanDraftListInput>;
    scope: MonitoringPlanDraftScope;
};

export type QueryMonitoringPlanListArgs = {
    input?: InputMaybe<MonitoringPlanListInput>;
};

export type QueryMonitoringPlansArgs = {
    input?: InputMaybe<MonitoringPlanListInput>;
    scope?: InputMaybe<MonitoringPlanScope>;
};

export type QueryOfficialByIdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryOfficialByIdsArgs = {
    ids: Array<Scalars['ID']['input']>;
};

export type QueryOfficialExportArgs = {
    input?: InputMaybe<OfficialExportInput>;
};

export type QueryOfficialListArgs = {
    input?: InputMaybe<OfficialListInput>;
};

export type QueryPublicEntityListArgs = {
    input?: InputMaybe<PublicEntityListInput>;
};

export type QueryQualityReportByIdArgs = {
    id: Scalars['QualityReportId']['input'];
    scope?: InputMaybe<QualityReportScope>;
};

export type QueryQualityReportByIdsArgs = {
    ids: Array<Scalars['QualityReportId']['input']>;
    scope?: InputMaybe<QualityReportScope>;
};

export type QueryQualityReportListArgs = {
    input?: InputMaybe<QualityReportListInput>;
};

export type QueryQualityReportsArgs = {
    input?: InputMaybe<QualityReportListInput>;
    scope?: InputMaybe<QualityReportScope>;
};

export type QueryUserByIdArgs = {
    id: Scalars['String']['input'];
};

export type QueryUserListArgs = {
    input?: InputMaybe<UserListInput>;
};

export type QueryWaterSupplierByIdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryWaterSupplierExportArgs = {
    input?: InputMaybe<WaterSupplierExportInput>;
};

export type QueryWaterSupplierListArgs = {
    input?: InputMaybe<WaterSupplierListInput>;
};

export type QueryWsAreaByIdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryWsAreaExportArgs = {
    input?: InputMaybe<WsAreaExportInput>;
};

export type QueryWsAreaListArgs = {
    input?: InputMaybe<WsAreaListInput>;
};

export type QueryWsAreaReaderListArgs = {
    input: WsAreaReaderListInput;
};

export type QueryWsEntityImportActionListByIdArgs = {
    id: Scalars['ID']['input'];
    limit?: InputMaybe<Scalars['Int']['input']>;
    startSeq?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryWsEntityImportByIdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryWsEntityImportListArgs = {
    input?: InputMaybe<WsEntityImportListInput>;
};

export type QueryWsEntityImportResultListByIdArgs = {
    id: Scalars['ID']['input'];
    limit?: InputMaybe<Scalars['Int']['input']>;
    startSeq?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryWsObjectByIdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryWsObjectExportArgs = {
    input?: InputMaybe<WsObjectExportInput>;
};

export type QueryWsObjectListArgs = {
    input?: InputMaybe<WsObjectListInput>;
};

export type QueryWsObjectReaderListArgs = {
    input: WsObjectReaderListInput;
};

export type QueryWsSamplePointByIdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryWsSamplePointExportArgs = {
    input?: InputMaybe<WsSamplePointExportInput>;
};

export type QueryWsSamplePointListArgs = {
    input?: InputMaybe<WsSamplePointListInput>;
};

export type QueryWsSamplePointReaderListArgs = {
    input: WsSamplePointReaderListInput;
};

export type QueryWsSystemByIdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryWsSystemExportArgs = {
    input?: InputMaybe<WsSystemExportInput>;
};

export type QueryWsSystemListArgs = {
    input?: InputMaybe<WsSystemListInput>;
};

export type QueryWsSystemReaderListArgs = {
    input: WsSystemReaderListInput;
};

export type QueryYearlyReportByIdArgs = {
    id: Scalars['YearlyReportId']['input'];
    scope?: InputMaybe<YearlyReportScope>;
};

export type QueryYearlyReportListArgs = {
    input?: InputMaybe<YearlyReportListInput>;
};

export type QueryYearlyReportsArgs = {
    input?: InputMaybe<YearlyReportListInput>;
    scope: YearlyReportScope;
};

export type ReaderSearch = {
    fields?: InputMaybe<Array<ReaderSearchField>>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export enum ReaderSearchField {
    Address = 'ADDRESS',
    Id = 'ID',
    Name = 'NAME'
}

export type SendQualityReports = {
    __typename?: 'SendQualityReports';
    failedIds: Array<Scalars['String']['output']>;
    successIds: Array<Scalars['String']['output']>;
};

/** Sampling site. */
export type Site = {
    __typename?: 'Site';
    id?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
};

export type SlimContact = {
    __typename?: 'SlimContact';
    comment?: Maybe<Scalars['String']['output']>;
    email?: Maybe<Array<Scalars['String']['output']>>;
    mailbox?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Array<Scalars['String']['output']>>;
};

export enum SortOrder {
    Asc = 'ASC',
    Desc = 'DESC'
}

export type SupervisingAuthority = {
    __typename?: 'SupervisingAuthority';
    examFreqAParam?: Maybe<Scalars['Int']['output']>;
    examFreqBParam?: Maybe<Scalars['Int']['output']>;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
};

export type SupervisingAuthorityInput = {
    examFreqAParam?: InputMaybe<Scalars['Int']['input']>;
    examFreqBParam?: InputMaybe<Scalars['Int']['input']>;
    id: Scalars['ID']['input'];
};

export type SuppliedDistrict = {
    __typename?: 'SuppliedDistrict';
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    numOfPeopleServed: Scalars['Int']['output'];
};

export type SuppliedDistrictInput = {
    id: Scalars['ID']['input'];
    name: Scalars['String']['input'];
    numOfPeopleServed: Scalars['Int']['input'];
};

export type UpdateAddress = {
    additional?: InputMaybe<Scalars['String']['input']>;
    house?: InputMaybe<Scalars['String']['input']>;
    place?: InputMaybe<Scalars['String']['input']>;
    street?: InputMaybe<Scalars['String']['input']>;
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContact = {
    comment?: InputMaybe<Scalars['String']['input']>;
    email?: InputMaybe<Array<Scalars['String']['input']>>;
    mailbox?: InputMaybe<Scalars['String']['input']>;
    phone?: InputMaybe<Array<Scalars['String']['input']>>;
    website?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSlimContact = {
    comment?: InputMaybe<Scalars['String']['input']>;
    email?: InputMaybe<Array<Scalars['String']['input']>>;
    mailbox?: InputMaybe<Scalars['String']['input']>;
    phone?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Logged-in user information returned by the `me` query. */
export type User = {
    __typename?: 'User';
    accessRole?: Maybe<UserAccessRole>;
    context?: Maybe<Scalars['String']['output']>;
    createdAt?: Maybe<Scalars['DateTime']['output']>;
    createdBy?: Maybe<Scalars['String']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    enabled: Scalars['Boolean']['output'];
    firstname?: Maybe<Scalars['String']['output']>;
    group?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    idp?: Maybe<Scalars['String']['output']>;
    lastname?: Maybe<Scalars['String']['output']>;
    notificationSettings?: Maybe<NotificationSettings>;
    ownerIdent?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
    updatedBy?: Maybe<Scalars['String']['output']>;
    username: Scalars['String']['output'];
};

/** Access information for the user's context. */
export type UserAccess = {
    __typename?: 'UserAccess';
    id?: Maybe<Scalars['String']['output']>;
    ty: ContextType;
    v: ContextVersion;
};

/** The user's role and access context. */
export type UserAccessRole = {
    __typename?: 'UserAccessRole';
    access: UserAccess;
    role: Scalars['String']['output'];
    subjectName?: Maybe<Scalars['String']['output']>;
};

export type UserFilter = {
    types?: InputMaybe<Array<PublicEntityType>>;
};

export type UserItem = {
    __typename?: 'UserItem';
    active: Scalars['Boolean']['output'];
    email?: Maybe<Scalars['String']['output']>;
    entityActive?: Maybe<Scalars['Boolean']['output']>;
    entityAddress?: Maybe<Scalars['String']['output']>;
    entityId?: Maybe<Scalars['ID']['output']>;
    entityKind: PublicEntityKind;
    entityName?: Maybe<Scalars['String']['output']>;
    entityR?: Maybe<Scalars['ID']['output']>;
    entityTy: PublicEntityType;
    firstName?: Maybe<Scalars['String']['output']>;
    group?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastName?: Maybe<Scalars['String']['output']>;
    modification: Modification;
    username?: Maybe<Scalars['String']['output']>;
};

export type UserList = {
    __typename?: 'UserList';
    items: Array<UserItem>;
    total: Scalars['Int']['output'];
};

export type UserListInput = {
    filter?: InputMaybe<UserFilter>;
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<UserSearch>;
    sort?: InputMaybe<UserSort>;
};

/** Input type for updating notification settings. */
export type UserNotificationSettingsInput = {
    monitoringPlanAutoDelete?: InputMaybe<Scalars['Boolean']['input']>;
    monitoringPlanStatus?: InputMaybe<Scalars['Boolean']['input']>;
    monitoringPlanStatusSelected?: Array<MonitoringPlanStatus>;
    qualityReportAutoDelete?: InputMaybe<Scalars['Boolean']['input']>;
    qualityReportReceived?: InputMaybe<Scalars['Boolean']['input']>;
    yearlyReport?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSearch = {
    fields?: InputMaybe<Array<UserSearchField>>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export enum UserSearchField {
    Email = 'EMAIL',
    EntityAddress = 'ENTITY_ADDRESS',
    EntityId = 'ENTITY_ID',
    EntityName = 'ENTITY_NAME',
    FirstName = 'FIRST_NAME',
    LastName = 'LAST_NAME',
    Username = 'USERNAME'
}

export type UserSort = {
    by?: InputMaybe<UserSortField>;
    order?: InputMaybe<SortOrder>;
};

export enum UserSortField {
    CreatedAt = 'CREATED_AT',
    CreatedBy = 'CREATED_BY',
    Email = 'EMAIL',
    EntityAddress = 'ENTITY_ADDRESS',
    EntityId = 'ENTITY_ID',
    EntityName = 'ENTITY_NAME',
    FirstName = 'FIRST_NAME',
    Group = 'GROUP',
    LastName = 'LAST_NAME',
    UpdatedAt = 'UPDATED_AT',
    UpdatedBy = 'UPDATED_BY',
    Username = 'USERNAME'
}

export type WaterSupplierAuthorityInfo = {
    __typename?: 'WaterSupplierAuthorityInfo';
    name: Scalars['String']['output'];
};

export type WaterSupplierAuthorityInfoInput = {
    name: Scalars['String']['input'];
};

export type WaterSupplierCompanyInfo = {
    __typename?: 'WaterSupplierCompanyInfo';
    name: Scalars['String']['output'];
};

export type WaterSupplierCompanyInfoInput = {
    name: Scalars['String']['input'];
};

export type WaterSupplierCreateFieldsInput = {
    address: CreateAddress;
    contact: CreateSlimContact;
    envId?: InputMaybe<Scalars['String']['input']>;
    envIdFmt?: InputMaybe<Scalars['String']['input']>;
    info: WaterSupplierInfoInput;
    isLegalOperator: Scalars['Boolean']['input'];
};

export type WaterSupplierCreateInput = {
    federalState: Scalars['String']['input'];
    fields: WaterSupplierCreateFieldsInput;
    parent?: InputMaybe<Scalars['ID']['input']>;
};

export type WaterSupplierExportInput = {
    filter?: InputMaybe<WaterSupplierFilter>;
    ids?: InputMaybe<Array<Scalars['ID']['input']>>;
    search?: InputMaybe<WaterSupplierSearch>;
    sort?: InputMaybe<WaterSupplierSort>;
};

export type WaterSupplierFilter = {
    branches?: InputMaybe<Scalars['Boolean']['input']>;
    editable?: InputMaybe<Scalars['Boolean']['input']>;
    federalStateId?: InputMaybe<Scalars['Int']['input']>;
    fullname?: InputMaybe<Scalars['Boolean']['input']>;
    lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type WaterSupplierInfo =
    | WaterSupplierAuthorityInfo
    | WaterSupplierCompanyInfo
    | WaterSupplierPersonInfo;

export type WaterSupplierInfoInput = {
    authority?: InputMaybe<WaterSupplierAuthorityInfoInput>;
    company?: InputMaybe<WaterSupplierCompanyInfoInput>;
    person?: InputMaybe<WaterSupplierPersonInfoInput>;
};

export type WaterSupplierItem = {
    __typename?: 'WaterSupplierItem';
    active: Scalars['Boolean']['output'];
    address: Address;
    branches: Scalars['Int']['output'];
    contact: SlimContact;
    editable?: Maybe<Scalars['Boolean']['output']>;
    envId?: Maybe<Scalars['String']['output']>;
    envIdFmt?: Maybe<XwasserCode>;
    id: Scalars['ID']['output'];
    info?: Maybe<WaterSupplierInfo>;
    isLegalOperator?: Maybe<Scalars['Boolean']['output']>;
    modification: Modification;
    name?: Maybe<Scalars['String']['output']>;
    parent?: Maybe<WaterSupplierParentItem>;
    province?: Maybe<Province>;
    r: Scalars['ID']['output'];
};

export type WaterSupplierList = {
    __typename?: 'WaterSupplierList';
    items: Array<WaterSupplierItem>;
    total: Scalars['Int']['output'];
};

export type WaterSupplierListInput = {
    filter?: InputMaybe<WaterSupplierFilter>;
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<WaterSupplierSearch>;
    sort?: InputMaybe<WaterSupplierSort>;
};

export type WaterSupplierParentItem = {
    __typename?: 'WaterSupplierParentItem';
    id?: Maybe<Scalars['ID']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    r?: Maybe<Scalars['ID']['output']>;
};

export type WaterSupplierPersonInfo = {
    __typename?: 'WaterSupplierPersonInfo';
    firstname: Scalars['String']['output'];
    lastname: Scalars['String']['output'];
    salutation: Scalars['String']['output'];
    title: Scalars['String']['output'];
};

export type WaterSupplierPersonInfoInput = {
    firstname: Scalars['String']['input'];
    lastname: Scalars['String']['input'];
    salutation: Scalars['String']['input'];
    title: Scalars['String']['input'];
};

export type WaterSupplierReaderInput = {
    id: Scalars['ID']['input'];
    reader: Array<Scalars['ID']['input']>;
};

export type WaterSupplierRemoveInput = {
    ids: Array<Scalars['ID']['input']>;
};

export type WaterSupplierSearch = {
    fields?: InputMaybe<Array<WaterSupplierSearchField>>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export enum WaterSupplierSearchField {
    Address = 'ADDRESS',
    Id = 'ID',
    Name = 'NAME'
}

export type WaterSupplierSort = {
    by?: InputMaybe<WaterSupplierSortField>;
    order?: InputMaybe<SortOrder>;
};

export enum WaterSupplierSortField {
    Address = 'ADDRESS',
    Branches = 'BRANCHES',
    CreatedAt = 'CREATED_AT',
    CreatedBy = 'CREATED_BY',
    House = 'HOUSE',
    Id = 'ID',
    Name = 'NAME',
    Place = 'PLACE',
    Street = 'STREET',
    UpdatedAt = 'UPDATED_AT',
    UpdatedBy = 'UPDATED_BY',
    Zip = 'ZIP'
}

export type WaterSupplierUpdateFieldsInput = {
    address?: InputMaybe<UpdateAddress>;
    contact?: InputMaybe<UpdateSlimContact>;
    envId?: InputMaybe<Scalars['String']['input']>;
    envIdFmt?: InputMaybe<Scalars['String']['input']>;
    info?: InputMaybe<WaterSupplierInfoInput>;
    isLegalOperator?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WaterSupplierUpdateInput = {
    fields: WaterSupplierUpdateFieldsInput;
    id: Scalars['ID']['input'];
};

export type WsAreaAccess = {
    __typename?: 'WsAreaAccess';
    direct: AccessValue;
    read: Scalars['Boolean']['output'];
    write: Scalars['Boolean']['output'];
};

export type WsAreaAdditionalAuthority = {
    __typename?: 'WsAreaAdditionalAuthority';
    editable: Scalars['Boolean']['output'];
    id?: Maybe<Scalars['ID']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    r?: Maybe<Scalars['ID']['output']>;
    ty: BasicEntityType;
};

export type WsAreaCreateFieldsInput = {
    additionalAuthorityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    comment?: InputMaybe<Scalars['String']['input']>;
    dailyWaterDelivery?: InputMaybe<Scalars['Decimal']['input']>;
    dateOfClosure?: InputMaybe<Scalars['DateTime']['input']>;
    dateOfEstablishment: Scalars['DateTime']['input'];
    examFreqAParam?: InputMaybe<Scalars['Int']['input']>;
    examFreqBParam?: InputMaybe<Scalars['Int']['input']>;
    geoEasting?: InputMaybe<Scalars['Decimal']['input']>;
    geoLatitude?: InputMaybe<Scalars['Decimal']['input']>;
    geoLongitude?: InputMaybe<Scalars['Decimal']['input']>;
    geoNorthing?: InputMaybe<Scalars['Decimal']['input']>;
    geoPosAndExtentFile?: InputMaybe<Scalars['Upload']['input']>;
    geoZone?: InputMaybe<Scalars['String']['input']>;
    ident: Scalars['String']['input'];
    lau2Code?: InputMaybe<Array<Scalars['String']['input']>>;
    name: Scalars['String']['input'];
    numOfPeopleServed?: InputMaybe<Scalars['Int']['input']>;
    reasonForClosure?: InputMaybe<Scalars['String']['input']>;
    refYearForDelivery?: InputMaybe<Scalars['Int']['input']>;
    successorIds?: InputMaybe<Array<Scalars['String']['input']>>;
    supervisingAuthorities?: InputMaybe<Array<SupervisingAuthorityInput>>;
    suppliedDistricts?: InputMaybe<Array<SuppliedDistrictInput>>;
};

export type WsAreaCreateInput = {
    authorityId: Scalars['ID']['input'];
    fields: WsAreaCreateFieldsInput;
    handOver?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WsAreaDetails = {
    __typename?: 'WsAreaDetails';
    active: Scalars['Boolean']['output'];
    additionalAuthorities: Array<WsAreaAdditionalAuthority>;
    authority?: Maybe<BasicEntityInfo>;
    comment?: Maybe<Scalars['String']['output']>;
    dailyWaterDelivery?: Maybe<Scalars['Decimal']['output']>;
    dateOfClosure?: Maybe<Scalars['DateTime']['output']>;
    dateOfEstablishment?: Maybe<Scalars['DateTime']['output']>;
    deliveryABSystems: BasicEntityInfoList;
    editable?: Maybe<Scalars['Boolean']['output']>;
    examFreqAParam?: Maybe<Scalars['Int']['output']>;
    examFreqBParam?: Maybe<Scalars['Int']['output']>;
    geoEasting?: Maybe<Scalars['Decimal']['output']>;
    geoLatitude?: Maybe<Scalars['Decimal']['output']>;
    geoLongitude?: Maybe<Scalars['Decimal']['output']>;
    geoNorthing?: Maybe<Scalars['Decimal']['output']>;
    geoPosAndExtent?: Maybe<WsAreaShapefile>;
    geoZone?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lau2Code?: Maybe<Array<Scalars['String']['output']>>;
    modification: Modification;
    name?: Maybe<Scalars['String']['output']>;
    numOfPeopleServed?: Maybe<Scalars['Int']['output']>;
    objects: BasicEntityInfoList;
    r: Scalars['ID']['output'];
    reasonForClosure?: Maybe<XwasserCode>;
    refYearForDelivery?: Maybe<Scalars['Int']['output']>;
    responsible?: Maybe<BasicEntityInfo>;
    successorIds?: Maybe<Array<Scalars['String']['output']>>;
    supervisingAuthorities?: Maybe<Array<SupervisingAuthority>>;
    suppliedDistricts?: Maybe<Array<SuppliedDistrict>>;
};

export type WsAreaDetailsDeliveryAbSystemsArgs = {
    input?: InputMaybe<WsSystemListInput>;
};

export type WsAreaDetailsObjectsArgs = {
    input?: InputMaybe<WsObjectListInput>;
};

export type WsAreaExportInput = {
    filter?: InputMaybe<WsAreaFilter>;
    ids?: InputMaybe<Array<Scalars['ID']['input']>>;
    search?: InputMaybe<WsAreaSearch>;
    sort?: InputMaybe<WsAreaSort>;
};

export type WsAreaFilter = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    editable?: InputMaybe<Scalars['Boolean']['input']>;
    federalStateId?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WsAreaItem = {
    __typename?: 'WsAreaItem';
    active: Scalars['Boolean']['output'];
    authority?: Maybe<BasicEntityInfo>;
    comment?: Maybe<Scalars['String']['output']>;
    dailyWaterDelivery?: Maybe<Scalars['Decimal']['output']>;
    dateOfClosure?: Maybe<Scalars['DateTime']['output']>;
    dateOfEstablishment?: Maybe<Scalars['DateTime']['output']>;
    editable?: Maybe<Scalars['Boolean']['output']>;
    examFreqAParam?: Maybe<Scalars['Int']['output']>;
    examFreqBParam?: Maybe<Scalars['Int']['output']>;
    geoEasting?: Maybe<Scalars['Decimal']['output']>;
    geoLatitude?: Maybe<Scalars['Decimal']['output']>;
    geoLongitude?: Maybe<Scalars['Decimal']['output']>;
    geoNorthing?: Maybe<Scalars['Decimal']['output']>;
    geoPosAndExtent?: Maybe<WsAreaShapefile>;
    geoZone?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lau2Code?: Maybe<Array<Scalars['String']['output']>>;
    modification: Modification;
    name?: Maybe<Scalars['String']['output']>;
    numOfPeopleServed?: Maybe<Scalars['Int']['output']>;
    r: Scalars['ID']['output'];
    reasonForClosure?: Maybe<XwasserCode>;
    refYearForDelivery?: Maybe<Scalars['Int']['output']>;
    responsible?: Maybe<BasicEntityInfo>;
    successorIds?: Maybe<Array<Scalars['String']['output']>>;
    supervisingAuthorities?: Maybe<Array<SupervisingAuthority>>;
    suppliedDistricts?: Maybe<Array<SuppliedDistrict>>;
};

export type WsAreaList = {
    __typename?: 'WsAreaList';
    items: Array<WsAreaItem>;
    total: Scalars['Int']['output'];
};

export type WsAreaListInput = {
    filter?: InputMaybe<WsAreaFilter>;
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<WsAreaSearch>;
    sort?: InputMaybe<WsAreaSort>;
};

export type WsAreaReaderCreateInput = {
    exclusive: Scalars['Boolean']['input'];
    id: Scalars['ID']['input'];
    reader: Array<Scalars['ID']['input']>;
};

export type WsAreaReaderFilter = {
    access: WsEntityAccessTy;
    direct?: InputMaybe<Scalars['Boolean']['input']>;
    exclusive?: InputMaybe<Scalars['Boolean']['input']>;
    federalStateId?: InputMaybe<Scalars['Int']['input']>;
    types?: InputMaybe<Array<WsEntityReaderType>>;
};

export type WsAreaReaderItem = {
    __typename?: 'WsAreaReaderItem';
    access?: Maybe<WsAreaAccess>;
    address?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    name?: Maybe<Scalars['String']['output']>;
    r: Scalars['ID']['output'];
    ty: WsEntityReaderType;
};

export type WsAreaReaderList = {
    __typename?: 'WsAreaReaderList';
    items: Array<WsAreaReaderItem>;
    total: Scalars['Int']['output'];
};

export type WsAreaReaderListInput = {
    filter?: InputMaybe<WsAreaReaderFilter>;
    id: Scalars['ID']['input'];
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<ReaderSearch>;
    sort?: InputMaybe<WsEntityReaderSort>;
};

export type WsAreaReaderRemoveInput = {
    id: Scalars['ID']['input'];
    reader: Array<Scalars['ID']['input']>;
};

export type WsAreaRemoveInput = {
    ids: Array<Scalars['ID']['input']>;
};

export type WsAreaSearch = {
    fields?: InputMaybe<Array<WsAreaSearchField>>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export enum WsAreaSearchField {
    Id = 'ID',
    Name = 'NAME'
}

export type WsAreaShapefile = {
    __typename?: 'WsAreaShapefile';
    filehash: Scalars['String']['output'];
    filename: Scalars['String']['output'];
    mimeType: Scalars['String']['output'];
    size: Scalars['Int']['output'];
    url: Scalars['String']['output'];
};

export type WsAreaSort = {
    by?: InputMaybe<WsAreaSortField>;
    order?: InputMaybe<SortOrder>;
};

export enum WsAreaSortField {
    CreatedAt = 'CREATED_AT',
    CreatedBy = 'CREATED_BY',
    Id = 'ID',
    Name = 'NAME',
    UpdatedAt = 'UPDATED_AT',
    UpdatedBy = 'UPDATED_BY'
}

export type WsAreaUpdateFieldsInput = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    additionalAuthorityIds?: InputMaybe<Array<Scalars['String']['input']>>;
    comment?: InputMaybe<Scalars['String']['input']>;
    dailyWaterDelivery?: InputMaybe<Scalars['Decimal']['input']>;
    dateOfClosure?: InputMaybe<Scalars['DateTime']['input']>;
    dateOfEstablishment?: InputMaybe<Scalars['DateTime']['input']>;
    examFreqAParam?: InputMaybe<Scalars['Int']['input']>;
    examFreqBParam?: InputMaybe<Scalars['Int']['input']>;
    geoEasting?: InputMaybe<Scalars['Decimal']['input']>;
    geoLatitude?: InputMaybe<Scalars['Decimal']['input']>;
    geoLongitude?: InputMaybe<Scalars['Decimal']['input']>;
    geoNorthing?: InputMaybe<Scalars['Decimal']['input']>;
    geoPosAndExtentFile?: InputMaybe<Scalars['Upload']['input']>;
    geoZone?: InputMaybe<Scalars['String']['input']>;
    lau2Code?: InputMaybe<Array<Scalars['String']['input']>>;
    name?: InputMaybe<Scalars['String']['input']>;
    numOfPeopleServed?: InputMaybe<Scalars['Int']['input']>;
    reasonForClosure?: InputMaybe<Scalars['String']['input']>;
    refYearForDelivery?: InputMaybe<Scalars['Int']['input']>;
    successorIds?: InputMaybe<Array<Scalars['String']['input']>>;
    supervisingAuthorities?: InputMaybe<Array<SupervisingAuthorityInput>>;
    suppliedDistricts?: InputMaybe<Array<SuppliedDistrictInput>>;
};

export type WsAreaUpdateInput = {
    authorityId?: InputMaybe<Scalars['ID']['input']>;
    fields: WsAreaUpdateFieldsInput;
    id: Scalars['ID']['input'];
};

export type WsAreaWriterUpdateInput = {
    id: Scalars['ID']['input'];
    writer: Scalars['ID']['input'];
};

export enum WsEntityAccessTy {
    All = 'ALL',
    Creatable = 'CREATABLE',
    Removable = 'REMOVABLE'
}

export type WsEntityImportAction = {
    __typename?: 'WsEntityImportAction';
    id: Scalars['Int']['output'];
    payload: Scalars['JSON']['output'];
    subject: Scalars['String']['output'];
    ts: Scalars['NaiveDateTime']['output'];
};

export type WsEntityImportActionList = {
    __typename?: 'WsEntityImportActionList';
    items: Array<WsEntityImportAction>;
    total: Scalars['Int']['output'];
};

export type WsEntityImportCreateInput = {
    file: Scalars['Upload']['input'];
    kind: WsEntityImportFileKind;
};

export enum WsEntityImportFileKind {
    Ods = 'ODS',
    Xls = 'XLS',
    Xlsb = 'XLSB',
    Xlsx = 'XLSX'
}

export type WsEntityImportItem = {
    __typename?: 'WsEntityImportItem';
    actions?: Maybe<Scalars['Int']['output']>;
    completed?: Maybe<Scalars['Int']['output']>;
    errors?: Maybe<Scalars['Int']['output']>;
    id: Scalars['ID']['output'];
    invalid?: Maybe<Scalars['Int']['output']>;
    kind?: Maybe<WsEntityImportFileKind>;
    mimeType?: Maybe<Scalars['String']['output']>;
    modification: Modification;
    name?: Maybe<Scalars['String']['output']>;
    processed?: Maybe<Scalars['Int']['output']>;
    responsible?: Maybe<BasicEntityInfo>;
    size?: Maybe<Scalars['Int']['output']>;
    stage?: Maybe<WsEntityImportStage>;
    state?: Maybe<WsEntityImportState>;
    valid?: Maybe<Scalars['Int']['output']>;
    wsAreas?: Maybe<Scalars['Int']['output']>;
    wsObjects?: Maybe<Scalars['Int']['output']>;
    wsSamplePoints?: Maybe<Scalars['Int']['output']>;
    wsSystems?: Maybe<Scalars['Int']['output']>;
};

export type WsEntityImportList = {
    __typename?: 'WsEntityImportList';
    items: Array<WsEntityImportItem>;
    total: Scalars['Int']['output'];
};

export type WsEntityImportListInput = {
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<WsEntityImportSearch>;
    sort?: InputMaybe<WsEntityImportSort>;
};

export type WsEntityImportRemoveInput = {
    ids: Array<Scalars['ID']['input']>;
};

export type WsEntityImportResultList = {
    __typename?: 'WsEntityImportResultList';
    items: Array<WsEntityImportAction>;
    total: Scalars['Int']['output'];
};

export type WsEntityImportSearch = {
    text?: InputMaybe<Scalars['String']['input']>;
};

export type WsEntityImportSort = {
    by?: InputMaybe<WsEntityImportSortField>;
    order?: InputMaybe<SortOrder>;
};

export enum WsEntityImportSortField {
    CreatedAt = 'CREATED_AT',
    CreatedBy = 'CREATED_BY',
    Id = 'ID',
    Name = 'NAME',
    UpdatedAt = 'UPDATED_AT',
    UpdatedBy = 'UPDATED_BY'
}

export enum WsEntityImportStage {
    Are = 'ARE',
    Non = 'NON',
    Obj = 'OBJ',
    Spt = 'SPT',
    Sys = 'SYS'
}

export enum WsEntityImportState {
    Fin = 'FIN',
    Pen = 'PEN',
    Pro = 'PRO',
    Rdy = 'RDY',
    Val = 'VAL'
}

export type WsEntityReaderSort = {
    by?: InputMaybe<WsEntityReaderSortField>;
    order?: InputMaybe<SortOrder>;
};

export enum WsEntityReaderSortField {
    Address = 'ADDRESS',
    Id = 'ID',
    Name = 'NAME'
}

export enum WsEntityReaderType {
    All = 'ALL',
    HdpGa = 'HDP_GA',
    HdpSo = 'HDP_SO',
    HdpWa = 'HDP_WA',
    Lab = 'LAB',
    LabB = 'LAB_B',
    Olb = 'OLB',
    OlbB = 'OLB_B',
    Wsp = 'WSP',
    WspB = 'WSP_B'
}

export type WsObjectAccess = {
    __typename?: 'WsObjectAccess';
    direct: AccessValue;
    indirect: WsObjectAccessIndirect;
    read: Scalars['Boolean']['output'];
    write: Scalars['Boolean']['output'];
};

export type WsObjectAccessIndirect = {
    __typename?: 'WsObjectAccessIndirect';
    spt: AccessValue;
    sys: AccessValue;
};

export type WsObjectCreateFieldsInput = {
    address?: InputMaybe<CreateAddressOpt>;
    altId?: InputMaybe<Scalars['String']['input']>;
    altIdFmt?: InputMaybe<Scalars['String']['input']>;
    areaId?: InputMaybe<Scalars['String']['input']>;
    comment?: InputMaybe<Scalars['String']['input']>;
    commissionDate?: InputMaybe<Scalars['DateTime']['input']>;
    decommissionDate?: InputMaybe<Scalars['DateTime']['input']>;
    envId?: InputMaybe<Scalars['String']['input']>;
    envIdFmt?: InputMaybe<Scalars['String']['input']>;
    frameworks: Array<WsObjectFrameworkInput>;
    geoEasting?: InputMaybe<Scalars['Decimal']['input']>;
    geoLatitude?: InputMaybe<Scalars['Decimal']['input']>;
    geoLongitude?: InputMaybe<Scalars['Decimal']['input']>;
    geoNorthing?: InputMaybe<Scalars['Decimal']['input']>;
    geoZone?: InputMaybe<Scalars['String']['input']>;
    kind: Scalars['String']['input'];
    name: Scalars['String']['input'];
    opState: Scalars['String']['input'];
};

export type WsObjectCreateInput = {
    authorityId: Scalars['ID']['input'];
    fields: WsObjectCreateFieldsInput;
    handOver?: InputMaybe<Scalars['Boolean']['input']>;
    releaseForOfficial?: InputMaybe<Scalars['Boolean']['input']>;
    systemId: Scalars['ID']['input'];
};

export type WsObjectDetails = {
    __typename?: 'WsObjectDetails';
    access?: Maybe<WsObjectAccess>;
    active: Scalars['Boolean']['output'];
    address: Address;
    altId?: Maybe<Scalars['String']['output']>;
    altIdFmt?: Maybe<XwasserCode>;
    areaId?: Maybe<Scalars['String']['output']>;
    authority?: Maybe<BasicEntityInfo>;
    comment?: Maybe<Scalars['String']['output']>;
    commissionDate?: Maybe<Scalars['DateTime']['output']>;
    decommissionDate?: Maybe<Scalars['DateTime']['output']>;
    editable?: Maybe<Scalars['Boolean']['output']>;
    envId?: Maybe<Scalars['String']['output']>;
    envIdFmt?: Maybe<XwasserCode>;
    frameworks: Array<XwasserCode>;
    geoEasting?: Maybe<Scalars['Decimal']['output']>;
    geoLatitude?: Maybe<Scalars['Decimal']['output']>;
    geoLongitude?: Maybe<Scalars['Decimal']['output']>;
    geoNorthing?: Maybe<Scalars['Decimal']['output']>;
    geoZone?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    isSysRelatedWsp?: Maybe<Scalars['Boolean']['output']>;
    kind?: Maybe<XwasserCode>;
    modification: Modification;
    name?: Maybe<Scalars['String']['output']>;
    official?: Maybe<Scalars['Boolean']['output']>;
    opState?: Maybe<XwasserCode>;
    r: Scalars['ID']['output'];
    responsible?: Maybe<BasicEntityInfo>;
    systems: BasicEntityInfoList;
    waterSuppliers: PublicEntityList;
};

export type WsObjectDetailsSystemsArgs = {
    input?: InputMaybe<WsSystemListInput>;
};

export type WsObjectDetailsWaterSuppliersArgs = {
    input?: InputMaybe<WsSystemRelatedWaterSupplierListInput>;
};

export type WsObjectExportInput = {
    filter?: InputMaybe<WsObjectFilter>;
    ids?: InputMaybe<Array<Scalars['ID']['input']>>;
    search?: InputMaybe<WsObjectSearch>;
    sort?: InputMaybe<WsObjectSort>;
};

export type WsObjectFilter = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    editable?: InputMaybe<Scalars['Boolean']['input']>;
    federalStateId?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    systemId?: InputMaybe<Scalars['String']['input']>;
};

export type WsObjectFrameworkInput = {
    code: Scalars['String']['input'];
};

export type WsObjectItem = {
    __typename?: 'WsObjectItem';
    active: Scalars['Boolean']['output'];
    address: Address;
    altId?: Maybe<Scalars['String']['output']>;
    altIdFmt?: Maybe<XwasserCode>;
    areaId?: Maybe<Scalars['String']['output']>;
    authority?: Maybe<BasicEntityInfo>;
    comment?: Maybe<Scalars['String']['output']>;
    commissionDate?: Maybe<Scalars['DateTime']['output']>;
    decommissionDate?: Maybe<Scalars['DateTime']['output']>;
    editable?: Maybe<Scalars['Boolean']['output']>;
    envId?: Maybe<Scalars['String']['output']>;
    envIdFmt?: Maybe<XwasserCode>;
    frameworks: Array<XwasserCode>;
    geoEasting?: Maybe<Scalars['Decimal']['output']>;
    geoLatitude?: Maybe<Scalars['Decimal']['output']>;
    geoLongitude?: Maybe<Scalars['Decimal']['output']>;
    geoNorthing?: Maybe<Scalars['Decimal']['output']>;
    geoZone?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    kind?: Maybe<XwasserCode>;
    modification: Modification;
    name?: Maybe<Scalars['String']['output']>;
    official?: Maybe<Scalars['Boolean']['output']>;
    opState?: Maybe<XwasserCode>;
    r: Scalars['ID']['output'];
    responsible?: Maybe<BasicEntityInfo>;
};

export type WsObjectList = {
    __typename?: 'WsObjectList';
    items: Array<WsObjectItem>;
    total: Scalars['Int']['output'];
};

export type WsObjectListInput = {
    filter?: InputMaybe<WsObjectFilter>;
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<WsObjectSearch>;
    sort?: InputMaybe<WsObjectSort>;
};

export type WsObjectReaderCreateInput = {
    exclusive: Scalars['Boolean']['input'];
    id: Scalars['ID']['input'];
    reader: Array<Scalars['ID']['input']>;
};

export type WsObjectReaderFilter = {
    access: WsEntityAccessTy;
    direct?: InputMaybe<Scalars['Boolean']['input']>;
    exclusive?: InputMaybe<Scalars['Boolean']['input']>;
    federalStateId?: InputMaybe<Scalars['Int']['input']>;
    types?: InputMaybe<Array<WsEntityReaderType>>;
};

export type WsObjectReaderItem = {
    __typename?: 'WsObjectReaderItem';
    access?: Maybe<WsObjectAccess>;
    address?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    name?: Maybe<Scalars['String']['output']>;
    r: Scalars['ID']['output'];
    ty: WsEntityReaderType;
};

export type WsObjectReaderList = {
    __typename?: 'WsObjectReaderList';
    items: Array<WsObjectReaderItem>;
    total: Scalars['Int']['output'];
};

export type WsObjectReaderListInput = {
    filter?: InputMaybe<WsObjectReaderFilter>;
    id: Scalars['ID']['input'];
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<ReaderSearch>;
    sort?: InputMaybe<WsEntityReaderSort>;
};

export type WsObjectReaderRemoveInput = {
    id: Scalars['ID']['input'];
    reader: Array<Scalars['ID']['input']>;
};

export type WsObjectReaderUpdateInput = {
    exclusive: Scalars['Boolean']['input'];
    id: Scalars['ID']['input'];
    reader: Scalars['ID']['input'];
};

export type WsObjectRemoveInput = {
    ids: Array<Scalars['ID']['input']>;
};

export type WsObjectSearch = {
    fields?: InputMaybe<Array<WsObjectSearchField>>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export enum WsObjectSearchField {
    Address = 'ADDRESS',
    Id = 'ID',
    Name = 'NAME'
}

export type WsObjectSort = {
    by?: InputMaybe<WsObjectSortField>;
    order?: InputMaybe<SortOrder>;
};

export enum WsObjectSortField {
    Address = 'ADDRESS',
    CreatedAt = 'CREATED_AT',
    CreatedBy = 'CREATED_BY',
    House = 'HOUSE',
    Id = 'ID',
    Name = 'NAME',
    Place = 'PLACE',
    Street = 'STREET',
    UpdatedAt = 'UPDATED_AT',
    UpdatedBy = 'UPDATED_BY',
    Zip = 'ZIP'
}

export type WsObjectUpdateFieldsInput = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    address?: InputMaybe<UpdateAddress>;
    altId?: InputMaybe<Scalars['String']['input']>;
    altIdFmt?: InputMaybe<Scalars['String']['input']>;
    areaId?: InputMaybe<Scalars['String']['input']>;
    comment?: InputMaybe<Scalars['String']['input']>;
    commissionDate?: InputMaybe<Scalars['DateTime']['input']>;
    decommissionDate?: InputMaybe<Scalars['DateTime']['input']>;
    envId?: InputMaybe<Scalars['String']['input']>;
    envIdFmt?: InputMaybe<Scalars['String']['input']>;
    frameworks?: InputMaybe<Array<WsObjectFrameworkInput>>;
    geoEasting?: InputMaybe<Scalars['Decimal']['input']>;
    geoLatitude?: InputMaybe<Scalars['Decimal']['input']>;
    geoLongitude?: InputMaybe<Scalars['Decimal']['input']>;
    geoNorthing?: InputMaybe<Scalars['Decimal']['input']>;
    geoZone?: InputMaybe<Scalars['String']['input']>;
    kind?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    opState?: InputMaybe<Scalars['String']['input']>;
};

export type WsObjectUpdateInput = {
    fields: WsObjectUpdateFieldsInput;
    id: Scalars['ID']['input'];
};

export type WsObjectWriterUpdateInput = {
    id: Scalars['ID']['input'];
    writer: Scalars['ID']['input'];
};

export type WsSamplePointAccess = {
    __typename?: 'WsSamplePointAccess';
    direct: AccessValue;
    indirect: WsSamplePointAccessIndirect;
    read: Scalars['Boolean']['output'];
    write: Scalars['Boolean']['output'];
};

export type WsSamplePointAccessIndirect = {
    __typename?: 'WsSamplePointAccessIndirect';
    obj: AccessValue;
    sys: AccessValue;
};

export type WsSamplePointCreateFieldsInput = {
    altId?: InputMaybe<Scalars['String']['input']>;
    altIdFmt?: InputMaybe<Scalars['String']['input']>;
    category: Scalars['String']['input'];
    comment?: InputMaybe<Scalars['String']['input']>;
    envId?: InputMaybe<Scalars['String']['input']>;
    envIdFmt?: InputMaybe<Scalars['String']['input']>;
    floor?: InputMaybe<Scalars['String']['input']>;
    medium: Array<WsSamplePointMediumInput>;
    name: Scalars['String']['input'];
    reportingObligation?: InputMaybe<Scalars['Boolean']['input']>;
    subCategory?: InputMaybe<Scalars['String']['input']>;
    treatmentOfWater?: InputMaybe<Array<WsSamplePointTreatmentOfWaterInput>>;
    typeOfExtInst: Scalars['String']['input'];
};

export type WsSamplePointCreateInput = {
    fields: WsSamplePointCreateFieldsInput;
    handOver?: InputMaybe<Scalars['Boolean']['input']>;
    objectId: Scalars['ID']['input'];
    releaseForOfficial?: InputMaybe<Scalars['Boolean']['input']>;
    systemId: Scalars['ID']['input'];
};

export type WsSamplePointExportInput = {
    filter?: InputMaybe<WsSamplePointFilter>;
    ids?: InputMaybe<Array<Scalars['ID']['input']>>;
    search?: InputMaybe<WsSamplePointSearch>;
    sort?: InputMaybe<WsSamplePointSort>;
};

export type WsSamplePointFilter = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    editable?: InputMaybe<Scalars['Boolean']['input']>;
    federalStateId?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    objectId?: InputMaybe<Scalars['ID']['input']>;
    systemId?: InputMaybe<Scalars['ID']['input']>;
};

export type WsSamplePointItem = {
    __typename?: 'WsSamplePointItem';
    active: Scalars['Boolean']['output'];
    address?: Maybe<Address>;
    altId?: Maybe<Scalars['String']['output']>;
    altIdFmt?: Maybe<XwasserCode>;
    authority?: Maybe<BasicEntityInfo>;
    category?: Maybe<XwasserCode>;
    comment?: Maybe<Scalars['String']['output']>;
    editable?: Maybe<Scalars['Boolean']['output']>;
    envId?: Maybe<Scalars['String']['output']>;
    envIdFmt?: Maybe<XwasserCode>;
    floor?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    medium: Array<XwasserCode>;
    modification: Modification;
    name?: Maybe<Scalars['String']['output']>;
    object?: Maybe<BasicEntityInfo>;
    official?: Maybe<Scalars['Boolean']['output']>;
    r: Scalars['ID']['output'];
    reportingObligation?: Maybe<Scalars['Boolean']['output']>;
    responsible?: Maybe<BasicEntityInfo>;
    subCategory?: Maybe<XwasserCode>;
    system?: Maybe<BasicEntityInfo>;
    treatmentOfWater: Array<XwasserCode>;
    typeOfExtInst?: Maybe<XwasserCode>;
    waterSupplier?: Maybe<BasicEntityInfo>;
};

export type WsSamplePointList = {
    __typename?: 'WsSamplePointList';
    items: Array<WsSamplePointItem>;
    total: Scalars['Int']['output'];
};

export type WsSamplePointListInput = {
    filter?: InputMaybe<WsSamplePointFilter>;
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<WsSamplePointSearch>;
    sort?: InputMaybe<WsSamplePointSort>;
};

export type WsSamplePointMediumInput = {
    code: Scalars['String']['input'];
};

export type WsSamplePointReaderCreateInput = {
    id: Scalars['ID']['input'];
    reader: Array<Scalars['ID']['input']>;
};

export type WsSamplePointReaderFilter = {
    access: WsEntityAccessTy;
    direct?: InputMaybe<Scalars['Boolean']['input']>;
    exclusive?: InputMaybe<Scalars['Boolean']['input']>;
    federalStateId?: InputMaybe<Scalars['Int']['input']>;
    types?: InputMaybe<Array<WsEntityReaderType>>;
};

export type WsSamplePointReaderItem = {
    __typename?: 'WsSamplePointReaderItem';
    access?: Maybe<WsSamplePointAccess>;
    address?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    name?: Maybe<Scalars['String']['output']>;
    r: Scalars['ID']['output'];
    ty: WsEntityReaderType;
};

export type WsSamplePointReaderList = {
    __typename?: 'WsSamplePointReaderList';
    items: Array<WsSamplePointReaderItem>;
    total: Scalars['Int']['output'];
};

export type WsSamplePointReaderListInput = {
    filter?: InputMaybe<WsSamplePointReaderFilter>;
    id: Scalars['ID']['input'];
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<ReaderSearch>;
    sort?: InputMaybe<WsEntityReaderSort>;
};

export type WsSamplePointReaderRemoveInput = {
    id: Scalars['ID']['input'];
    reader: Array<Scalars['ID']['input']>;
};

export type WsSamplePointRemoveInput = {
    ids: Array<Scalars['ID']['input']>;
};

export type WsSamplePointSearch = {
    fields?: InputMaybe<Array<WsSamplePointSearchField>>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export enum WsSamplePointSearchField {
    Address = 'ADDRESS',
    Id = 'ID',
    Name = 'NAME'
}

export type WsSamplePointSort = {
    by?: InputMaybe<WsSamplePointSortField>;
    order?: InputMaybe<SortOrder>;
};

export enum WsSamplePointSortField {
    Address = 'ADDRESS',
    CreatedAt = 'CREATED_AT',
    CreatedBy = 'CREATED_BY',
    House = 'HOUSE',
    Id = 'ID',
    Name = 'NAME',
    Place = 'PLACE',
    Street = 'STREET',
    UpdatedAt = 'UPDATED_AT',
    UpdatedBy = 'UPDATED_BY',
    Zip = 'ZIP'
}

export type WsSamplePointTreatmentOfWaterInput = {
    code: Scalars['String']['input'];
};

export type WsSamplePointUpdateFieldsInput = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    altId?: InputMaybe<Scalars['String']['input']>;
    altIdFmt?: InputMaybe<Scalars['String']['input']>;
    category?: InputMaybe<Scalars['String']['input']>;
    comment?: InputMaybe<Scalars['String']['input']>;
    envId?: InputMaybe<Scalars['String']['input']>;
    envIdFmt?: InputMaybe<Scalars['String']['input']>;
    floor?: InputMaybe<Scalars['String']['input']>;
    medium?: InputMaybe<Array<WsSamplePointMediumInput>>;
    name?: InputMaybe<Scalars['String']['input']>;
    reportingObligation?: InputMaybe<Scalars['Boolean']['input']>;
    subCategory?: InputMaybe<Scalars['String']['input']>;
    treatmentOfWater?: InputMaybe<Array<WsSamplePointTreatmentOfWaterInput>>;
    typeOfExtInst?: InputMaybe<Scalars['String']['input']>;
};

export type WsSamplePointUpdateInput = {
    fields: WsSamplePointUpdateFieldsInput;
    id: Scalars['ID']['input'];
};

export type WsSamplePointWriterUpdateInput = {
    id: Scalars['ID']['input'];
    writer: Scalars['ID']['input'];
};

export type WsSystemAccess = {
    __typename?: 'WsSystemAccess';
    direct: AccessValue;
    indirect: WsSystemAccessIndirect;
    read: Scalars['Boolean']['output'];
    write: Scalars['Boolean']['output'];
};

export type WsSystemAccessIndirect = {
    __typename?: 'WsSystemAccessIndirect';
    obj: AccessValue;
    spt: AccessValue;
};

export type WsSystemCreateFieldsInput = {
    altId?: InputMaybe<Scalars['String']['input']>;
    altIdFmt?: InputMaybe<Scalars['String']['input']>;
    comment?: InputMaybe<Scalars['String']['input']>;
    connectedSystems?: InputMaybe<Array<Scalars['ID']['input']>>;
    kind: Scalars['String']['input'];
    name: Scalars['String']['input'];
    supervisingAuthorities?: InputMaybe<Array<SupervisingAuthorityInput>>;
    suppliedDistricts?: InputMaybe<Array<SuppliedDistrictInput>>;
};

export type WsSystemCreateInput = {
    authorityId: Scalars['ID']['input'];
    fields: WsSystemCreateFieldsInput;
    handOver?: InputMaybe<Scalars['Boolean']['input']>;
    waterSupplier: WsSystemWaterSupplierInput;
};

export type WsSystemDetails = {
    __typename?: 'WsSystemDetails';
    access?: Maybe<WsSystemAccess>;
    active: Scalars['Boolean']['output'];
    altId?: Maybe<Scalars['String']['output']>;
    altIdFmt?: Maybe<XwasserCode>;
    areaIds?: Maybe<Array<Scalars['String']['output']>>;
    authority?: Maybe<BasicEntityInfo>;
    comment?: Maybe<Scalars['String']['output']>;
    connectedSystemIds?: Maybe<Array<Scalars['ID']['output']>>;
    connectedSystems: BasicEntityInfoList;
    editable?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    kind?: Maybe<XwasserCode>;
    modification: Modification;
    name?: Maybe<Scalars['String']['output']>;
    objects: BasicEntityInfoList;
    r: Scalars['ID']['output'];
    responsible?: Maybe<BasicEntityInfo>;
    supervisingAuthorities?: Maybe<Array<SupervisingAuthority>>;
    suppliedDistricts?: Maybe<Array<SuppliedDistrict>>;
    waterSupplier?: Maybe<BasicEntityInfo>;
};

export type WsSystemDetailsObjectsArgs = {
    input?: InputMaybe<WsObjectListInput>;
};

export type WsSystemExportInput = {
    filter?: InputMaybe<WsSystemFilter>;
    ids?: InputMaybe<Array<Scalars['ID']['input']>>;
    search?: InputMaybe<WsSystemSearch>;
    sort?: InputMaybe<WsSystemSort>;
};

export type WsSystemFilter = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    editable?: InputMaybe<Scalars['Boolean']['input']>;
    federalStateId?: InputMaybe<Scalars['Int']['input']>;
    lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
    objectId?: InputMaybe<Scalars['String']['input']>;
    waterSupplierId?: InputMaybe<Scalars['String']['input']>;
};

export type WsSystemItem = {
    __typename?: 'WsSystemItem';
    active: Scalars['Boolean']['output'];
    altId?: Maybe<Scalars['String']['output']>;
    altIdFmt?: Maybe<XwasserCode>;
    areaIds?: Maybe<Array<Scalars['String']['output']>>;
    authority?: Maybe<BasicEntityInfo>;
    comment?: Maybe<Scalars['String']['output']>;
    connectedSystemIds?: Maybe<Array<Scalars['ID']['output']>>;
    editable?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    kind?: Maybe<XwasserCode>;
    modification: Modification;
    name?: Maybe<Scalars['String']['output']>;
    r: Scalars['ID']['output'];
    responsible?: Maybe<BasicEntityInfo>;
    supervisingAuthorities?: Maybe<Array<SupervisingAuthority>>;
    suppliedDistricts?: Maybe<Array<SuppliedDistrict>>;
    waterSupplier?: Maybe<BasicEntityInfo>;
};

export type WsSystemList = {
    __typename?: 'WsSystemList';
    items: Array<WsSystemItem>;
    total: Scalars['Int']['output'];
};

export type WsSystemListInput = {
    filter?: InputMaybe<WsSystemFilter>;
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<WsSystemSearch>;
    sort?: InputMaybe<WsSystemSort>;
};

export type WsSystemMpIdentCreateInput = {
    systemId: Scalars['ID']['input'];
    year: Scalars['Int']['input'];
};

export type WsSystemReaderCreateInput = {
    exclusive: Scalars['Boolean']['input'];
    id: Scalars['ID']['input'];
    reader: Array<Scalars['ID']['input']>;
};

export type WsSystemReaderFilter = {
    access: WsEntityAccessTy;
    direct?: InputMaybe<Scalars['Boolean']['input']>;
    exclusive?: InputMaybe<Scalars['Boolean']['input']>;
    federalStateId?: InputMaybe<Scalars['Int']['input']>;
    types?: InputMaybe<Array<WsEntityReaderType>>;
};

export type WsSystemReaderItem = {
    __typename?: 'WsSystemReaderItem';
    access?: Maybe<WsSystemAccess>;
    address?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    name?: Maybe<Scalars['String']['output']>;
    r: Scalars['ID']['output'];
    ty: WsEntityReaderType;
};

export type WsSystemReaderList = {
    __typename?: 'WsSystemReaderList';
    items: Array<WsSystemReaderItem>;
    total: Scalars['Int']['output'];
};

export type WsSystemReaderListInput = {
    filter?: InputMaybe<WsSystemReaderFilter>;
    id: Scalars['ID']['input'];
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<ReaderSearch>;
    sort?: InputMaybe<WsEntityReaderSort>;
};

export type WsSystemReaderRemoveInput = {
    id: Scalars['ID']['input'];
    reader: Array<Scalars['ID']['input']>;
};

export type WsSystemReaderUpdateInput = {
    exclusive: Scalars['Boolean']['input'];
    id: Scalars['ID']['input'];
    reader: Scalars['ID']['input'];
};

export type WsSystemRelatedWaterSupplierListInput = {
    pagination?: InputMaybe<Pagination>;
    search?: InputMaybe<PublicEntitySearch>;
    sort?: InputMaybe<PublicEntitySort>;
};

export type WsSystemRemoveInput = {
    ids: Array<Scalars['ID']['input']>;
};

export type WsSystemSearch = {
    fields?: InputMaybe<Array<WsSystemSearchField>>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export enum WsSystemSearchField {
    Id = 'ID',
    Name = 'NAME'
}

export type WsSystemSort = {
    by?: InputMaybe<WsSystemSortField>;
    order?: InputMaybe<SortOrder>;
};

export enum WsSystemSortField {
    CreatedAt = 'CREATED_AT',
    CreatedBy = 'CREATED_BY',
    Id = 'ID',
    Name = 'NAME',
    UpdatedAt = 'UPDATED_AT',
    UpdatedBy = 'UPDATED_BY'
}

export type WsSystemUpdateFieldsInput = {
    active?: InputMaybe<Scalars['Boolean']['input']>;
    altId?: InputMaybe<Scalars['String']['input']>;
    altIdFmt?: InputMaybe<Scalars['String']['input']>;
    comment?: InputMaybe<Scalars['String']['input']>;
    connectedSystems?: InputMaybe<Array<Scalars['ID']['input']>>;
    kind?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    supervisingAuthorities?: InputMaybe<Array<SupervisingAuthorityInput>>;
    suppliedDistricts?: InputMaybe<Array<SuppliedDistrictInput>>;
    waterSupplier?: InputMaybe<WsSystemWaterSupplierInput>;
};

export type WsSystemUpdateInput = {
    fields: WsSystemUpdateFieldsInput;
    id: Scalars['ID']['input'];
};

export type WsSystemWaterSupplierInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
};

export type WsSystemWriterUpdateInput = {
    id: Scalars['ID']['input'];
    writer: Scalars['ID']['input'];
};

export type XwasserCode = {
    __typename?: 'XwasserCode';
    code?: Maybe<Scalars['String']['output']>;
    desc?: Maybe<Scalars['String']['output']>;
    text?: Maybe<Scalars['String']['output']>;
};

/** yearly report item */
export type YearlyReportItem = {
    __typename?: 'YearlyReportItem';
    id?: Maybe<Scalars['YearlyReportId']['output']>;
    receivedAt?: Maybe<Scalars['DateTime']['output']>;
    sentAt?: Maybe<Scalars['DateTime']['output']>;
    title: Scalars['String']['output'];
    uploadedAt: Scalars['DateTime']['output'];
    url?: Maybe<Scalars['String']['output']>;
};

export type YearlyReportList = {
    __typename?: 'YearlyReportList';
    items: Array<YearlyReportItem>;
    limit?: Maybe<Scalars['Int']['output']>;
    page?: Maybe<Scalars['Int']['output']>;
    total?: Maybe<Scalars['Int']['output']>;
};

export type YearlyReportListInput = {
    filter?: InputMaybe<ListFilter>;
    sort?: InputMaybe<YearlyReportSort>;
};

export enum YearlyReportScope {
    Hdp = 'HDP',
    Olb = 'OLB'
}

export type YearlyReportSort = {
    by?: InputMaybe<YearlyReportSortField>;
    order?: InputMaybe<SortOrder>;
};

export enum YearlyReportSortField {
    ReceivedAt = 'RECEIVED_AT',
    SentAt = 'SENT_AT',
    Title = 'TITLE',
    UploadedAt = 'UPLOADED_AT'
}
